// Common root
import DefaultView from '@/views/DefaultView.vue';
import PopupView from '@/views/PopupView.vue';
import ServiceRegisterView from '@/views/service/register/ServiceRegisterView.vue';

// Basic
import MainView from '@/views/MainView.vue';
import LoginView from '@/views/LoginView.vue';
import ExternalAccess from '@/views/ExternalAccess.vue';

// 상품관리
import GlobalProductOptionsPopupIframe from '@/views/product/GlobalProductOptionsPopupIframe.vue';
import ProductList from '@/views/product/ProductList.vue';
import ProductListIframe from '@/views/product/ProductListIframe.vue';
import ProductDisplayOrderIframe from '@/views/product/ProductDisplayOrderIframe.vue';
import CopyMallProduct from '@/views/product/productListPopup/CopyMallProduct.vue';
import ProductAddList from '@/views/product/ProductAddList.vue';
import ProductAddListIframe from '@/views/product/ProductAddListIframe.vue';
import ProductAdd from '@/views/product/ProductAdd.vue';
import ProductAddIframe from '@/views/product/ProductAddIframe.vue';
import ProductAddBulkIframe from '@/views/product/ProductAddBulkIframe.vue';
import JudgementList from '@/views/product/judgement/JudgementList.vue';
import JudgementListIframe from '@/views/product/judgement/JudgementListIframe.vue';
import CommissionRate from '@/views/display/CommissionRate.vue';
import CommissionRateIframe from '@/views/display/CommissionRateIframe.vue';
import ProductReviewList from '@/views/product/review/ReviewList.vue'; // 상품평 관리 - 조회
import ProductReviewListIframe from '@/views/product/review/ReviewListIframe.vue';
import ProductReportList from '@/views/product/review/ReportList.vue';
import ChangeDisplayStatus from '@/views/product/review/ChangeDisplayStatus.vue';
import ChangeBestReview from '@/views/product/review/ChangeBestReview.vue';
import ReviewDetailIframe from '@/views/product/review/ReviewDetailIframe.vue';
import MarketingProductIframe from '@/views/product/MarketingProductIframe.vue';
// import ReviewDetail from '@/views/product/review/ReviewDetail.vue';
import ReportDetail from '@/views/product/review/ReportDetail.vue';
import RestockList from '@/views/product/restock/RestockList.vue';
import RestockListIframe from '@/views/product/restock/RestockListIframe.vue';
import RestockDetail from '@/views/product/restock/RestockDetail.vue';
import RestockDetailIframe from '@/views/product/restock/RestockDetailIframe.vue';
import RestockSms from '@/views/product/restock/popup/RestockSms.vue';
import RestockSmsSendIframe from '@/views/product/restock/popup/RestockSmsSendIframe.vue';
import ProductInquiry from '@/views/product/ProductInquiry.vue'; // 상품 문의 관리
import ProductInquiryIframe from '@/views/product/ProductInquiryIframe.vue';
import DeliveryConditionGroupList from '@/views/delivery/DeliveryConditionGroupList.vue';
import DeliveryWarehouseList from '@/views/delivery/DeliveryWarehouseList.vue';
import DeliveryAreaFeeList from '@/views/delivery/DeliveryAreaFeeList.vue';
import DeliveryAreaFeeModifyForm from '@/views/delivery/DeliveryAreaFeeModifyForm.vue';
import DeliveryAreaFeeModifyFormIframe from '@/views/delivery/DeliveryAreaFeeModifyFormIframe.vue';
import DeliveryAreaFeeAddForm from '@/views/delivery/DeliveryAreaFeeAddForm.vue';
import DeliveryWarehouseAddForm from '@/views/delivery/DeliveryWarehouseAddForm.vue';
import ModifyPopup from '@/views/delivery/ModifyPopup.vue';
import Management from '@/views/product/stock/Management.vue';
import ManagementIframe from '@/views/product/stock/ManagementIframe.vue';
import BulkManagementIframe from '@/views/product/stock/BulkManagementIframe.vue';
import StockModify from '@/views/product/stock/popup/StockModify.vue';
import StockExcelUpload from '@/views/product/stock/popup/StockExcelUpload.vue';
import ProductCustomPropertyIframe from '@/views/product/ProductCustomPropertyIframe.vue';
import ProductCustomPropertyEditIframe from '@/views/product/ProductCustomPropertyEditIframe.vue';
import PopupCustomProperty from '@/views/product/PopupCustomProperty.vue';
import ManagementCustomProperty from '@/views/product/popup/ManagementCustomProperty.vue';
import CustomProperty from '@/views/product/productListPopup/CustomProperty.vue';
import ProductBulkImageUpload from '@/views/product/ProductBulkImageUpload.vue';
import ProductBulkImageList from '@/views/product/ProductBulkImageList.vue';
import ProductBulkImageUploadGuide from '@/views/product/ProductBulkImageUploadGuide.vue';
// import StickerList from '@/views/product/StickerList.vue';
import StickerListIframe from '@/views/product/StickerListIframe.vue';
import ProductStickerAddForm from '@/views/product/ProductStickerAddForm.vue';
import ProductDutyAddForm from '@/views/product/ProductDutyAddForm.vue';
import SetProduct from '@/views/product/SetProduct.vue';
import CertificationAddForm from '@/views/product/CertificationAddForm.vue';
import DeliveryConditionDetailPopup from '@/views/delivery/DeliveryConditionDetailPopup.vue';
import DeliveryTemplateAddForm from '@/views/delivery/DeliveryTemplateAddForm.vue';
import ProductOptionAddForm from '@/views/product/ProductOptionAddForm.vue';
import ProductOptionImageAddForm from '@/views/product/ProductOptionImageAddForm.vue';
import ProductOptionImageBatchAddForm from '@/views/product/ProductOptionImageBatchAddForm.vue';
import OtherOptionLoad from '@/views/product/OtherOptionLoad.vue';
import ProductPopSearch from '@/views/product/ProductPopSearch.vue';
import DisplayCategoryInfo from '@/views/product/productListPopup/DisplayCategoryInfo.vue';
import EditImages from '@/views/product/productListPopup/EditImages.vue';
import ModifySaleStatus from '@/views/product/productListPopup/ModifySaleStatus.vue';
import ModifySalePriceAndImmediateDiscount from '@/views/product/productListPopup/ModifySalePriceAndImmediateDiscount.vue';
import ModifyFrontDisplay from '@/views/product/productListPopup/ModifyFrontDisplay.vue';
import ModifySalePeriod from '@/views/product/productListPopup/ModifySalePeriod.vue';
import ModifySalePrice from '@/views/product/productListPopup/ModifySalePrice.vue';
import ModifyImmediateDiscount from '@/views/product/productListPopup/ModifyImmediateDiscount.vue';
import ModifyPromotionText from '@/views/product/productListPopup/ModifyPromotionText.vue';
import BatchConfirm from '@/views/product/productListPopup/BatchConfirm.vue';
import UrlDirectDisplay from '@/views/product/productListPopup/UrlDirectDisplay.vue';
import PromotionsChange from '@/views/product/productListPopup/PromotionsChange.vue';
import PriceComparisonIframe from '@/views/product/productListPopup/PriceComparisonIframe.vue';
import CommissionPurchaseIframe from '@/views/product/productListPopup/CommissionPurchaseIframe.vue';
import ComparingPriceSite from '@/views/product/productListPopup/ComparingPriceSite.vue';
import IconChangeIframe from '@/views/product/productListPopup/IconChangeIframe.vue';
import ProductOptionsPopupIframe from '@/views/product/ProductOptionsPopupIframe.vue';
import ProductCategoryListPopupIframe from '@/views/product/ProductCategoryListPopupIframe.vue';
import ProductDeliveryDatePopupIframe from '@/views/product/ProductDeliveryDatePopupIframe.vue';
import ProductCustomPropertiesPopupIframe from '@/views/product/ProductCustomPropertiesPopupIframe.vue';
import ProductDeliveryInfoPopupIframe from '@/views/product/ProductDeliveryInfoPopupIframe.vue';
import ProductDescriptionPopupIframe from '@/views/product/ProductDescriptionPopupIframe.vue';
import ProductDescriptionTemplatePopupIframe from '@/views/product/ProductDescriptionTemplatePopupIframe.vue';
import ProductDiscountPricePopupIframe from '@/views/product/ProductDiscountPricePopupIframe.vue';
import ProductDiscountSettingPopupIframe from '@/views/product/ProductDiscountSettingPopupIframe.vue';
import ProductDisplayCategoryBatchPopupIframe from '@/views/product/ProductDisplayCategoryBatchPopupIframe.vue';
import ProductDisplayStatusPopupIframe from '@/views/product/ProductDisplayStatusPopupIframe.vue';
import ProductExcludeInSearchPopupIframe from '@/views/product/ProductExcludeInSearchPopupIframe.vue';
import ProductInformationDisclosurePopupIframe from '@/views/product/ProductInformationDisclosurePopupIframe.vue';
import ProductManagerBatchPopupIframe from '@/views/product/ProductManagerBatchPopupIframe.vue';
import ProductPromotionPopupIframe from '@/views/product/ProductPromotionPopupIframe.vue';
import ProductModifyPromotionPopupIframe from '@/views/product/ProductModifyPromotionPopupIframe.vue';
import ProductSalesPeriodPopupIframe from '@/views/product/ProductSalesPeriodPopupIframe.vue';
import ProductSalesPricePopupIframe from '@/views/product/ProductSalesPricePopupIframe.vue';
import ProductSalesStatusSettingPopupIframe from '@/views/product/ProductSalesStatusSettingPopupIframe.vue';
import ProductScreeningPopupIframe from '@/views/product/ProductScreeningPopupIframe.vue';
import ProductScreeningBatchPopupIframe from '@/views/product/ProductScreeningBatchPopupIframe.vue';
import ProductSloganPopupIframe from '@/views/product/ProductSloganPopupIframe.vue';
import ProductOptionSearchPopupIframe from '@/views/product/ProductOptionSearchPopupIframe.vue';
import ProductWithOptionsSearchPopupIframe from '@/views/product/ProductWithOptionsSearchPopupIframe.vue';
import ProductCopyPopupIframe from '@/views/product/ProductCopyPopupIframe.vue';
import ProductGroupManagementCodePopupIframe from '@/views/product/ProductGroupManagementCodePopupIframe.vue';
import ProductCommissionPurchasePopupIframe from '@/views/product/ProductCommissionPurchasePopupIframe.vue';
import ProductIconPopupIframe from '@/views/product/ProductIconPopupIframe.vue';
import ProductCertificationIframe from '@/views/product/ProductCertificationIframe.vue';
import ModifyPromotion from '@/views/product/productListPopup/ModifyPromotion.vue';
import ModifyDelivery from '@/views/product/productListPopup/ModifyDelivery.vue';
import DeliveryDate from '@/views/product/productListPopup/DeliveryDate.vue';
import RecurringPaymentsProductManagement from '@/views/product/recurringPayments/RecurringPaymentsProductManagement.vue';
import RecurringPaymentsProductManagementIframe from '@/views/product/RecurringPaymentsProductManagementIframe.vue';
import RecurringPaymentsProductSettingChange from '@/views/product/recurringPayments/popup/RecurringPaymentsProductSettingChange.vue';
import RecurringPaymentsProductRegister from '@/views/product/recurringPayments/RecurringPaymentsProductRegister.vue';
import RecurringPaymentsProductRegisterIframe from '@/views/product/RecurringPaymentsProductRegisterIframe.vue';
import ReviewExceptSetting from '@/views/product/review/ReviewExceptSetting.vue';
// 주문관리
import OrderPayFail from '@/views/order/OrderPayFail.vue';
import OrderPayFailIframe from '@/views/order/OrderPayFailIframe.vue';
import OrderHoldDelivery from '@/views/order/OrderHoldDelivery.vue';
import OrderHoldDeliveryIframe from '@/views/order/OrderHoldDeliveryIframe.vue';
import OrderList from '@/views/order/OrderList.vue';
import OrderListIframe from '@/views/order/OrderListIframe.vue';
import InactiveMemberOrderIframe from '@/views/order/InactiveMemberOrderIframe.vue';
import OrderDeposit from '@/views/order/OrderDeposit.vue';
import OrderDepositWaitIframe from '@/views/order/OrderDepositWaitIframe.vue';
import OrderPayDone from '@/views/order/OrderPayDone.vue';
import OrderPayDoneIframe from '@/views/order/OrderPayDoneIframe.vue';
import OrderBuyConfirm from '@/views/order/OrderBuyConfirm.vue';
import OrderBuyConfirmIframe from '@/views/order/OrderBuyConfirmIframe.vue';
import OrderDeliveryDone from '@/views/order/OrderDeliveryDone.vue';
import OrderDeliveryDoneIframe from '@/views/order/OrderDeliveryDoneIframe.vue';
import OrderProductPrepare from '@/views/order/OrderProductPrepare.vue';
import OrderProductPrepareIframe from '@/views/order/OrderProductPrepareIframe.vue';
import DeliveryPrepare from '@/views/order/DeliveryPrepare.vue';
import DeliveryPrepareIframe from '@/views/order/DeliveryPrepareIframe.vue';
import OrderDeliverying from '@/views/order/OrderDeliverying.vue';
import OrderDeliveringIframe from '@/views/order/OrderDeliveringIframe.vue';
import ManualOrder from '@/views/order/ManualOrder.vue';
import OrderDetail from '@/views/order/OrderDetail.vue';
import OrderDetailIframe from '@/views/order/OrderDetailIframe.vue';
import OrderPreviousDetailIframe from '@/views/order/OrderPreviousDetailIframe.vue';
import ManualConfirm from '@/views/order/ManualConfirm.vue';
import ManualCoupon from '@/views/order/popup/ManualCoupon.vue';
import OrderFirstDiscount from '@/views/order/popup/OrderFirstDiscount.vue';
import Benefit from '@/views/order/popup/Benefit.vue';
import DeliveryFirstAmtDetail from '@/views/order/popup/DeliveryFirstAmtDetail.vue';
import OrderRecurringPayments from '@/views/order/OrderRecurringPayments.vue';
import SubscriptionChangeNotificationIframe from '@/views/order/SubscriptionChangeNotificationIframe.vue';
import RecurringPaymentsIframe from '@/views/order/RecurringPaymentsIframe.vue';
// 클레임관리
import CancelList from '@/views/claim/CancelList.vue';
import CancelIframe from '@/views/claim/CancelIframe.vue';
import ExchangeList from '@/views/claim/ExchangeList.vue';
import ExchangeIframe from '@/views/claim/ExchangeIframe.vue';
import ReturnList from '@/views/claim/ReturnList.vue';
import ReturnIframe from '@/views/claim/ReturnIframe.vue';
import RefundsList from '@/views/claim/RefundsList.vue';
import RefundIframe from '@/views/claim/RefundIframe.vue';
import CsList from '@/views/claim/CsList.vue';
import CsLogIframe from '@/views/claim/CsLogIframe.vue';
import MessageList from '@/views/claim/MessageList.vue';
import TaskMessageIframe from '@/views/claim/TaskMessageIframe.vue';
import ViewPopup from '@/views/claim/popup/ViewPopup.vue';
import ExchangeProduct from '@/views/claim/ExchangeProduct.vue';
import CsModifyPopup from '@/views/claim/CsModifyPopup.vue';
import CancelPopup from '@/views/claim/CancelPopup.vue';
import CancelAllPopup from '@/views/claim/CancelAllPopup.vue';
import ReturnPopup from '@/views/claim/ReturnPopup.vue';
import ModifyAddress from '@/views/claim/ModifyAddress.vue';
import ExchangePopup from '@/views/claim/ExchangePopup.vue';
// 회원관리
import MemberRegisterIframe from '@/views/member/MemberRegisterIframe.vue';
import MemberEditIframe from '@/views/member/MemberEditIframe.vue';
import MemberGroup from '@/views/member/MemberGroupIframe.vue';
import DormantMemberIframe from '@/views/member/DormantMemberIframe.vue';
import WithdrawalMemberIframe from '@/views/member/WithdrawalMemberIframe.vue';
import MemberListIframe from '@/views/member/MemberListIframe.vue';
import CollectionSettingIframe from '@/views/member/CollectionSettingIframe.vue';
// import MemberGrade from '@/views/member/MemberGrade.vue';
// import MemberGroup from '@/views/member/MemberGroup.vue';
// import MemberExpel from '@/views/member/MemberExpel.vue';
import MemberGradeUpdate from '@/views/member/popup/GradeUpdate.vue';
import MemberGroupUpdate from '@/views/member/popup/GroupUpdate.vue';
import MemberAccumulate from '@/views/member/popup/Accumulate.vue';
import MemberGiveCoupon from '@/views/member/popup/GiveCoupon.vue';
import MemberGroupList from '@/views/member/popup/GroupList.vue';
import MemberPopList from '@/views/member/popup/List.vue';
import MemberSearchIframe from '@/views/member/popup/MemberSearchIframe.vue';
import MemberGradeEvaluation from '@/views/member/popup/MemberGradeEvaluation.vue';
import Recipient from '@/views/mail/popup/RecipientTarget.vue';
import MemberTarget from '@/views/member/popup/Targets.vue';
import ExpelMember from '@/views/member/popup/ExpelMember.vue';
import WithdrawCoupon from '@/views/member/popup/WithdrawCoupon.vue';
import ProhibitMember from '@/views/member/popup/ProhibitMember.vue';
import TemporaryPassword from '@/views/member/popup/TemporaryPassword.vue';
// import MemberCrm from '@/views/member/popup/MemberCrm.vue';// 원본
import MemberCrmIframe from '@/views/member/popup/MemberCrmIframe.vue'; // Iframe
// import MemberCrmSummary from '@/components/member/popup/memberCrm/contents/MemberCrmSummary.vue'; // 원본
// import MemberCrmMemberDetail from '@/components/member/popup/memberCrm/contents/MemberCrmMemberDetail.vue'; // 원본
// Iframe
// import MemberCrmOrderDetail from '@/components/member/popup/memberCrm/contents/MemberCrmOrderDetail.vue'; // 원본
// Iframe
// import MemberCrmBenefitDetail from '@/components/member/popup/memberCrm/contents/MemberCrmBenefitDetail.vue'; // 원본
// Iframe
// import MemberCrmBenefitDetailMileage from '@/components/member/popup/memberCrm/contents/MemberCrmBenefitDetailMileage.vue'; // 원본
// Iframe
// import MemberCrmInquiryDetail from '@/components/member/popup/memberCrm/contents/InquiryDetail.vue'; // 원본
// Iframe
// 전시관리
import EventListIframe from '@/views/event/EventListIframe.vue';
import EventAddFormIframe from '@/views/event/EventAddFormIframe.vue';
import PopupCouponGuide from '@/views/event/PopupCouponGuide.vue';
import PopSearchCoupon from '@/views/event/PopSearchCoupon.vue';
import ProductMainListIframe from '@/views/appearance/ProductMainListIframe.vue';
import ProductMainAddIframe from '@/views/appearance/ProductMainAddIframe.vue';
import BannerList from '@/views/banner/BannerList.vue';
import HeadlessBanners from '@/views/banner/HeadlessBanners.vue';
import HeadlessBannersAdd from '@/views/banner/HeadlessBannersAdd.vue';
import HeadlessBannersEdit from '@/views/banner/HeadlessBannersEdit.vue';
import SkinBanners from '@/views/banner/SkinBanners.vue';
import SkinBannersAdd from '@/views/banner/SkinBannersAdd.vue';
import SkinBannersEdit from '@/views/banner/SkinBannersEdit.vue';
import PopupBannerDisplayOption from '@/components/banner/popup/PopupBannerDisplayOption.vue';
import DisplayCategory from '@/views/display/DisplayCategory.vue';
import DisplayCategoryIframe from '@/views/display/DisplayCategoryIframe.vue';
import DisplayPriorityIframe from '@/views/display/DisplayPriorityIframe.vue';
import BrandIframe from '@/views/display/BrandIframe.vue';
import DisplayCategoryExcelBatchRegisterIframe from '@/views/display/popup/DisplayCategoryExcelBatchRegisterIframe.vue';
import PopupList from '@/views/display/popup/List.vue';
import PopupDetail from '@/views/display/popup/Detail.vue';
import ProductPriority from '@/views/product/ProductPriority.vue';
// 운영관리
import InquiryList from '@/views/inquiry/InquiryList.vue'; // 1:1 문의 관리
import InquiryListIframe from '@/views/inquiry/InquiryListIframe.vue';
import TypeConfig from '@/views/inquiry/TypeConfig.vue';
import InquiryTemplate from '@/views/manage/inquiry/InquiryTemplate.vue';
import TypeAndAdmin from '@/views/inquiry/popup/TypeAndAdmin.vue';
import InquiryDetailPopup from '@/views/inquiry/popup/InquiryDetailPopup.vue'; // 원본
import InquiryDetailPopupIframe from '@/views/inquiry/popup/InquiryDetailPopupIframe.vue'; // 원본
import ArticleList from '@/views/board/article/ArticleList.vue'; // 게시글 관리
import ArticleListIframe from '@/views/board/article/ArticleListIframe.vue';
import Boards from '@/views/board/board/Boards.vue'; // 게시판 관리
import BoardsIframe from '@/views/board/board/BoardsIframe.vue';
import AccumulationPayment from '@/views/accumulation/AccumulationPayment.vue';
import AccumulationConfiguration from '@/views/accumulation/AccumulationConfiguration.vue';
import AccumulationSettingIframe from '@/views/accumulation/AccumulationSettingIframe.vue';
import AccumulationPaymentDeductIframe from '@/views/accumulation/AccumulationPaymentDeductIframe.vue';
import AccumulationMain from '@/views/accumulation/AccumulationMain.vue';
import MessageIframe from '@/views/member/MessageIframe.vue';
import PaymentListPopup from '@/views/accumulation/popup/PaymentListPopup.vue';
import DisplayGradeInfoPopup from '@/views/accumulation/popup/DisplayGradeInfo.vue';
import DisplayGroupInfoPopup from '@/views/accumulation/popup/DisplayGroupInfo.vue';
import AccumulationPopup from '@/views/accumulation/AccumulationPopup.vue';
import PaymentRequestModify from '@/views/accumulation/PaymentRequestModify.vue';
import SmsDispatch from '@/views/manage/sms/SmsDispatch.vue';
import SmsSendList from '@/views/manage/sms/SmsSendList.vue';
import SmsUsageList from '@/views/manage/sms/SmsUsageList.vue';
import SmsRejectIframe from '@/views/manage/sms/SmsRejectIframe.vue';
// import SmsAuto from '@/views/manage/sms/AutoSms.vue';
// import SmsTemplateConfig from '@/views/manage/sms/SmsTemplateConfig.vue';
import ExcelBatchRegistrationPopup from '@/views/accumulation/ExcelBatchRegistrationPopup.vue';
import SmsTemplateList from '@/views/manage/sms/popup/SmsTemplateList.vue';
import SmsRecipientList from '@/views/manage/sms/popup/SmsRecipientList.vue';
import MailIframe from '@/views/mail/MailIframe.vue';
import MailUsageList from '@/views/mail/UsageList.vue';
import SendList from '@/views/mail/SendList.vue';
import TemplateConfig from '@/views/mail/TemplateConfig.vue';
import AutoMail from '@/views/mail/AutoMail.vue';
import TemplateList from '@/views/mail/popup/TemplateList.vue';
import RecipientList from '@/views/mail/popup/RecipientList.vue';
import AccumulationConfigurationModify from '@/views/accumulation/AccumulationConfigurationModify.vue';
// 프로모션관리
// import DiscountView from '@/views/promotion/DiscountView.vue';
// import DiscountAddForm from '@/views/promotion/DiscountAddForm.vue';
// import CouponList from '@/views/promotion/CouponList.vue';
import CouponIssueIframe from '@/views/promotion/CouponIssueIframe.vue';
import CouponSettingIframe from '@/views/promotion/CouponSettingIframe.vue';
// import DiscountView from '@/views/promotion/DiscountView.vue';
// import DiscountAddForm from '@/views/promotion/DiscountAddForm.vue';
import AdditionalDiscountManagementIframe from '@/views/promotion/additionalDiscount/ManagementIframe.vue';
import AdditionalDiscountModificationIframe from '@/views/promotion/additionalDiscount/ModificationIframe.vue';
import AdditionalDiscountRegistrationIframe from '@/views/promotion/additionalDiscount/RegistrationIframe.vue';
// import CouponList from '@/views/promotion/CouponList.vue';
// import CouponDetail from '@/views/promotion/CouponDetail.vue';
import IssuePlanAddForm from '@/views/promotion/IssuePlanAddForm.vue';
// import CouponIssuePlanList from '@/views/promotion/CouponIssuePlanList.vue';
import CouponIssuePlanListIframe from '@/views/promotion/CouponIssuePlanListIframe.vue';
import CouponUseListPopup from '@/views/promotion/CouponUseListPopup.vue';
import CouponPopupDetail from '@/views/promotion/CouponPopupDetail.vue';
import MemberTargetDetail from '@/views/promotion/popup/MemberTargetDetail.vue';
import DiscountTargetMember from '@/views/promotion/popup/DiscountTargetMember.vue';
// 파트너관리
import PartnerList from '@/views/partner/PartnerList.vue';
import PartnerListIframe from '@/views/partner/PartnerListIframe.vue';
import PartnerEditPage from '@/views/partner/PartnerEditPage.vue';
import PartnerEditPageIframe from '@/views/partner/PartnerEditPageIframe.vue';
import PartnerRegister from '@/views/partner/PartnerRegister.vue';
import PartnerRegisterIframe from '@/views/partner/PartnerRegisterIframe.vue';
import PartnerContract from '@/views/partner/PartnerContract.vue';
import PartnerContractIframe from '@/views/partner/PartnerContractIframe.vue';
import PartnerCopy from '@/views/partner/PartnerCopy.vue';
import PartnerCopyIframe from '@/views/partner/PartnerCopyIframe.vue';
import PartnerPool from '@/views/partner/PartnerPool.vue';
import PartnerNew from '@/views/partner/PartnerNew.vue';
import PartnerNewIframe from '@/views/partner/PartnerNewIframe.vue';
import ContractDown from '@/views/partner/popup/ContractDown.vue';
import ChangeMd from '@/views/partner/popup/ChangeMd.vue';
import NoticeListIframe from '@/views/board/notice/NoticeListIframe.vue';
import SettlementPartner from '@/views/settlement/Partner.vue';
import SettlementPartnerIframe from '@/views/settlement/PartnerIframe.vue';
import SettlementList from '@/views/settlement/List.vue';
import SettlementListIframe from '@/views/settlement/ListIframe.vue';
import NoticeListMoveNotice from '@/views/board/notice/NoticeListMoveNotice.vue';
import EditNoticeByNoticeNo from '@/views/board/notice/EditNoticeByNoticeNo.vue';
import PopupContract from '@/views/contract/PopupContract.vue';
import OperationGroupAddIframe from '@/views/partner/OperationGroupAddIframe.vue';
import OperationGroupListIframe from '@/views/partner/OperationGroupListIframe.vue';
import OperationGroupEditIframe from '@/views/partner/OperationGroupEditIframe.vue';
// 서비스관리
import MallList from '@/views/mall/MallList.vue';
import MallAddForm from '@/views/mall/MallAddForm.vue';
import MallForm from '@/views/mall/MallForm.vue';
import SettlementExcelPopup from '@/views/mall/popup/SettlementExcelPopup.vue';
import GroupList from '@/views/authority/GroupList.vue';
import GroupListIframe from '@/views/authority/GroupListIframe.vue';
import GroupAddForm from '@/views/authority/GroupAddForm.vue';
import GroupAddFormIframe from '@/views/authority/GroupAddFormIframe.vue';
import GroupPopup from '@/views/authority/GroupPopup.vue';
import AdminList from '@/views/admin/AdminList.vue';
import AdminListIframe from '@/views/admin/AdminListIframe.vue';
import AdminAdd from '@/views/admin/AdminAdd.vue';
import AdminAddIframe from '@/views/admin/AdminAddIframe.vue';
import AdminEdit from '@/views/admin/AdminEdit.vue';
import AdminEditIframe from '@/views/admin/AdminEditIframe.vue';
import AdminDepartment from '@/views/admin/AdminDepartment.vue';
import ChildAdminDepartment from '@/components/admin/ChildAdminDepartment.vue';
import Jobduty from '@/components/admin/Jobduty.vue';
import OrderExtraConfigIframe from '@/views/service/OrderExtraConfigIframe.vue';
import SettlementAdjustmentList from '@/views/settlement/SettlementAdjustmentList.vue';
import SettlementAdjustmentDetail from '@/views/settlement/SettlementAdjustmentDetail.vue';
import ServiceInfoPrev from '@/views/service/ServiceInfo.vue';
import ServiceInfoIframe from '@/views/service/ServiceInfoIframe.vue';
import SecuritySetting from '@/views/service/SecuritySetting.vue';
import PrivacyAccessHistories from '@/views/service/PrivacyAccessHistories.vue';
import TermsIframe from '@/views/terms/TermsIframe.vue';
import PrivacyAccessHistoriesIframe from '@/views/service/PrivacyAccessHistoriesIframe.vue';
import Ecommerce from '@/views/terms/tab/Ecommerce.vue';
import Introduction from '@/views/terms/tab/Introduction.vue';
import Collection from '@/views/terms/tab/Collection.vue';
import Withdrawal from '@/views/terms/tab/Withdrawal.vue';
import Access from '@/views/terms/tab/Access.vue';
import PersonalInfo from '@/views/terms/tab/PersonalInfo.vue';
import HistoryPop from '@/views/terms/popup/HistoryPop.vue';
import NoticeService from '@/views/board/notice/NoticeService.vue';
import FaqList from '@/views/board/faq/FaqList.vue';
import ArticleMove from '@/views/board/article/popup/ArticleMove.vue';
import ArticleForm from '@/views/board/article/popup/ArticleForm.vue';
import QueryNoticeByNoticeNo from '@/views/board/notice/QueryNoticeByNoticeNo.vue';
import QueryFaqByFaqNo from '@/views/board/faq/QueryFaqByFaqNo.vue';
import AdminPasswordByKey from '@/views/admin/AdminPasswordByKey.vue'; // 20210215 hslee 이메일 링크로부터 오픈되는 어드민 비밀번호 변경 페이지

// 통계
import MemberPeriod from '@/views/statistic/member/PeriodInfo.vue';
import MemberPeriodIframe from '@/views/statistic/member/PeriodInfoIframe.vue';
import SalesPeriod from '@/views/statistic/SalesPeriod.vue';
import SalesPeriodIframe from '@/views/statistic/SalesPeriodIframe.vue';
import SalesProduct from '@/views/statistic/sales/product/SalesStatisticProduct.vue';
import SalesCategory from '@/views/statistic/sales/category/SalesStatistic.vue';
import StatisticDiscount from '@/views/statistic/promotion/additionalDiscount/AdditionalDiscount.vue';
import StatisticCoupon from '@/views/statistic/promotion/coupons/ProductAndCartCoupon.vue';
// 통계 통합
import StatisticPromotionAdditionalDiscount from '@/views/statistic/StatisticPromotionAdditionalDiscount.vue';
import StatisticPromotionCouponIframe from '@/views/statistic/StatisticPromotionCouponIframe.vue';

// 정산관리
// import FeePolicy from '@/views/feepolicy/FeePolicy.vue';
import FeePolicyIframe from '@/views/feepolicy/FeePolicyIframe.vue';
import FeePolicyGuide from '@/views/feepolicy/popup/FeePolicyGuide.vue';
// ETC
import DesignEditor from '@/views/design/editor/DesignEditor.vue';
import ServiceRegisterAgreeTerms from '@/components/service/register/ServiceRegisterAgreeTerms.vue';
import ServiceRegisterForm from '@/components/service/register/ServiceRegisterForm.vue';
import ServiceMasterRegisterForm from '@/components/service/register/ServiceMasterRegisterForm.vue';
import ServiceMasterRegisterCompletePage from '@/components/service/register/ServiceMasterRegisterCompletePage.vue';
import AgreeTermsForm from '@/views/admin/service/AgreeTermsForm.vue';
import RegisterForm from '@/views/admin/service/RegisterForm.vue';
import RegisterFormIframe from '@/views/admin/service/RegisterFormIframe.vue';
import RegisterCompletePage from '@/views/admin/service/RegisterCompletePage.vue';
import AddressPopup from '@/views/address/AddressPopup.vue';
import MemberNotFound from '@/views/etc/MemberNotFound.vue';
import ClaimNotFound from '@/views/etc/ClaimNotFound.vue';
import FooterServicePrivacy from '@/views/privacy/FooterServicePrivacy.vue';
import FooterServicePrivacyOld from '@/views/privacy/FooterServicePrivacyOld.vue';
import ErrorPageUnauthorized from '@/views/etc/ErrorPageUnauthorized.vue';
import NoPermission from '@/views/etc/NoPermission.vue';
import PageNotFound from '@/views/etc/PageNotFound.vue';
import MemberHasDetach from '@/views/etc/MemberHasDetach.vue';
// 엑셀
import { RouteConfig } from 'vue-router';
import { PremiumExcelCreateMenu } from 'supporter';
import DelayProductOrderPopup from '@/views/order/popup/DelayProductOrderPopup.vue';
import EditGroupManagementCodeIframe from '@/views/product/productListPopup/EditGroupManagementCodeIframe.vue';
import FreeGiftContainer from '@/views/promotion/freeGift/FreeGiftContainer.vue';
// import FreeGiftCondition from '@/views/promotion/freeGift/conditionList/FreeGiftCondition.vue';
// import FreeGiftConfiguration from '@/views/promotion/freeGift/configuration/FreeGiftConfiguration.vue';
import FreeGiftConditionIframe from '@/views/promotion/freeGift/conditionList/FreeGiftConditionIframe.vue';
import FreeGiftConfigurationIframe from '@/views/promotion/freeGift/configuration/FreeGiftConfigurationIframe.vue';

import InstagramCodeReceiver from '@/views/instagram/InstagramCodeReceiver.vue';
import PromotionOptionPopSearch from '@/views/promotion/popup/PromotionOptionPopSearch.vue';
import CollectReturnPopup from '@/views/claim/popup/CollectReturnPopup.vue';
// import ConditionRegistration from '@/views/promotion/freeGift/conditionForm/ConditionRegistration.vue';
import ConditionRegistrationIframe from '@/views/promotion/freeGift/conditionForm/ConditionRegistrationIframe.vue';
import FreeGifts from '@/views/order/popup/FreeGifts.vue';
import ChangeAdmin from '@/views/product/productListPopup/ChangeAdmin.vue';

// 통합
import Addition from '@/views/appearance/Addition.vue';
import DesignPopup from '@/views/appearance/DesignPopup.vue';

import AppList from '@/views/app/AppList.vue';
import AppAll from '@/views/app/AppAll.vue';
import MemberGradeIframe from '@/views/member/MemberGradeIframe.vue';
import DesignSkinList from '@/views/appearance/DesignSkinList.vue';
import OauthCodeReceiver from '@/views/OauthCodeReceiver.vue';
import DomainDetailIframe from '@/views/domainSsl/DomainDetailIframe.vue';
import DomainSslIframe from '@/views/domainSsl/DomainSslIframe.vue';
import SslDetailIframe from '@/views/domainSsl/SslDetailIframe.vue';
import ExternalServiceIframe from '@/views/externalService/ExternalServiceIframe.vue';
import ExternalScriptVariableGuide from '@/views/externalService/ExternalScriptVariableGuideIframe.vue';
import ServerExcelDownloadIframe from '@/views/excel/popup/ServerExcelDownloadIframe.vue';
import PreviousOrdersIframe from '@/views/order/OrderPreviousIframe.vue';
import OrderHoldByReservationIframe from '@/views/order/OrderHoldByReservationIframe.vue';
// FIXME 제거 예정
import OrderHoldByReservation from '@/views/order/OrderHoldByReservation.vue';

import PaycoConfigIframe from '@/views/payco/PaycoConfigIframe.vue';
import NaverPayConfigIframe from '@/views/naverpay/NaverPayConfigIframe.vue';
import NaverShoppingConfigIframe from '@/views/naverShoppingConfig/NaverShoppingConfigIframe.vue';
import PgConfigIframe from '@/views/pg/PgConfigIframe.vue';
import CrmGroupList from '@/views/aggregator/CrmGroupList.vue';
import CrmGroupCreate from '@/views/aggregator/CrmGroupCreate.vue';
import TossPaymentConfigIframe from '@/views/tossPaymentConfig/TossPaymentConfigIframe.vue';

type ShopByRouteConfig = RouteConfig & {
  meta?: {
    nonMember?: boolean;
    historyName?: string; // 이것도 enum 일 것으로 유추되나 정의 안되어있음.
    excelCreateMenuKey?: PremiumExcelCreateMenu;
  };
};

const routes: ShopByRouteConfig[] = [
  // Basic
  {
    path: '/',
    name: 'Main',
    component: MainView,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      nonMember: true,
      // historyName: 'LOGIN'
    },
  },
  //통합로그인
  {
    path: '/oauth/redirect',
    name: 'OauthCodeReceiver',
    component: OauthCodeReceiver,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/external-access',
    name: 'ExternalAccess',
    component: ExternalAccess,
    meta: {
      nonMember: true,
    },
  },

  // Common root Default
  {
    path: '',
    component: DefaultView,
    children: [
      {
        path: 'appearance/addition',
        name: 'Addition',
        component: Addition,
      },
      // 디자인 팝업
      {
        path: 'appearance/custom/popup',
        name: 'DesignPopup',
        component: DesignPopup,
      },
      {
        path: 'appearance/custom/popup/registration',
        name: 'DesignPopupRegister',
        component: DesignPopup,
      },
      {
        path: 'appearance/custom/popup/modify',
        name: 'DesignPopupModify',
        component: DesignPopup,
      },
      {
        path: '/appearance/skin',
        name: 'DesignSkinList',
        component: DesignSkinList,
      },
      {
        path: '/app/list',
        name: 'AppList',
        component: AppList,
      },
      {
        path: '/app/all',
        name: 'AppAll',
        component: AppAll,
      },
      // FIXME
      {
        path: 'product/list-prev',
        name: 'ProductList',
        component: ProductList,
        meta: {
          // 상품관리 > 상품정보 조회/수정
          excelCreateMenuKey: 'PREMIUM_PRODUCT_LIST',
        },
      },
      // 상품관리
      {
        path: 'product/list',
        name: 'ProductListIframe',
        component: ProductListIframe,
        meta: {
          // 상품관리 > 상품정보 조회/수정
          excelCreateMenuKey: 'PREMIUM_PRODUCT_LIST',
        },
      },
      {
        path: 'product/addList-prev',
        name: 'ProductAddList',
        component: ProductAddList,
      },
      {
        path: 'product/marketing',
        name: 'marketingProduct',
        component: MarketingProductIframe,
      },
      {
        path: 'product/marketing/:content',
        name: 'marketingProduct',
        component: MarketingProductIframe,
      },
      {
        path: 'product/marketing',
        name: 'marketingProduct',
        component: MarketingProductIframe,
      },
      {
        path: 'product/addList',
        name: 'ProductAddListIframe',
        component: ProductAddListIframe,
      },
      {
        path: 'product/add-prev',
        name: 'AddProduct',
        component: ProductAdd,
      },
      {
        path: 'product/add',
        name: 'ProductAddIframe',
        component: ProductAddIframe,
      },
      {
        path: 'product/management/set/add',
        name: 'ProductAddIframe',
        component: ProductAddIframe,
      },
      {
        path: 'product/edit-prev/:productNo',
        name: 'EditProduct',
        component: ProductAdd,
      },
      {
        path: 'product/edit',
        name: 'EditProduct',
        component: ProductAddIframe,
      },
      {
        path: 'product/management/set/edit',
        name: 'ProductAddIframe',
        component: ProductAddIframe,
      },
      {
        path: 'product/copy-prev/:productNo',
        name: 'CopyProduct',
        component: ProductAdd,
      },
      {
        path: 'product/copy',
        name: 'CopyProduct',
        component: ProductAddIframe,
      },
      {
        path: 'product/management/bulk/add',
        name: 'ProductAddBulk',
        component: ProductAddBulkIframe,
      },
      {
        path: 'product/judgement/list-prev',
        name: 'JudgementList',
        component: JudgementList,
      },
      {
        path: 'category/commissionRate-prev',
        name: 'CommissionRatePrev',
        component: CommissionRate,
      },
      {
        path: 'product/judgement/list',
        name: 'JudgementListIframe',
        component: JudgementListIframe,
      },
      {
        path: 'category/commissionRate',
        name: 'CommissionRate',
        component: CommissionRateIframe,
      },
      {
        path: 'review-prev',
        name: 'ProductReviewListPrev',
        component: ProductReviewList,
        meta: {
          historyName: 'PRODUCT_REVIEW',
        },
      },
      {
        path: 'review-prev/report',
        name: 'ProductReportListPrev',
        component: ProductReportList,
        meta: {
          historyName: 'PRODUCT_REVIEW_REPORT',
        },
      },
      {
        path: 'review-prev/except',
        name: 'ProductReviewExceptPrev',
        component: ReviewExceptSetting,
        meta: {
          historyName: 'PRODUCT_REVIEW_EXCEPT',
        },
      },
      {
        path: 'review',
        name: 'ProductReview',
        redirect: { name: 'ProductReviewList' },
        component: ProductReviewListIframe,
        meta: {
          historyName: 'PRODUCT_REVIEW',
        },
      },
      {
        path: 'review/list',
        name: 'ProductReviewList',
        component: ProductReviewListIframe,
        meta: {
          historyName: 'PRODUCT_REVIEW',
        },
      },
      {
        path: 'review/report',
        name: 'ProductReportList',
        component: ProductReviewListIframe,
        meta: {
          historyName: 'PRODUCT_REVIEW_REPORT',
        },
      },
      {
        path: 'review/except',
        name: 'ProductReviewExcept',
        component: ProductReviewListIframe,
        meta: {
          historyName: 'PRODUCT_REVIEW_EXCEPT',
        },
      },
      {
        path: 'review/setting',
        name: 'ProductReviewSetting',
        component: ProductReviewListIframe,
      },
      {
        path: 'product/inquiry-prev',
        name: 'ProductInquiryPrev',
        component: ProductInquiry,
        meta: {
          historyName: 'PRODUCT_INQUIRY',
          // 상품관리 > 상품문의 관리
          excelCreateMenuKey: 'PREMIUM_PRODUCT_INQUIRY_LIST',
        },
      },
      {
        path: 'product/inquiry',
        name: 'ProductInquiry',
        redirect: {name: 'ProductInquiryIframe'},
        component: ProductInquiryIframe,
      },
      {
        path: 'product/inquiry/list',
        name: 'ProductInquiryIframe',
        component: ProductInquiryIframe,
        meta: {
          historyName: 'PRODUCT_INQUIRY',
          // 상품관리 > 상품문의 관리
          excelCreateMenuKey: 'PREMIUM_PRODUCT_INQUIRY_LIST',
        },
      },
      {
        path: 'product/inquiry/setting',
        name: 'ProductInquirySetting',
        component: ProductInquiryIframe,
      },
      {
        path: 'product/wmsList', // FIXME : 이 페이지 라우팅이 안되어있어서 임시 라우팅
        name: 'FIXME',
        component: PageNotFound,
        meta: {
          // 상품관리 > 연동상품정보 조회
          excelCreateMenuKey: 'PREMIUM_PRODUCT_SYNC',
        },
      },
      {
        path: 'delivery/condition/group/list',
        name: 'DeliveryConditionGroupList',
        component: DeliveryConditionGroupList,
      },
      {
        path: 'warehouse/list',
        name: 'DeliveryWarehouseList',
        component: DeliveryWarehouseList,
      },
      {
        path: 'deliveryAreaFee/list',
        name: 'DeliveryAreaFeeList',
        component: DeliveryAreaFeeList,
      },
      {
        path: 'product/stock/management-prev',
        name: 'Management',
        component: Management,
        meta: {
          // 상품관리 > 상품재고관리
          excelCreateMenuKey: 'PREMIUM_PRODUCT_STOCK',
        },
      },
      {
        path: 'product/stock/management',
        name: 'ManagementIframe',
        component: ManagementIframe,
      },
      {
        path: '/product/bulk-management/edit/excel',
        name: 'bulkManagementEdit',
        component: BulkManagementIframe,
      },
      {
        path: 'product/restock',
        name: 'Restock',
        component: RestockListIframe,
      },
      {
        path: 'product/restock-prev',
        name: 'RestockPrev',
        component: RestockList,
      },
      {
        path: 'product/restock/detail',
        name: 'RestockDetail',
        component: RestockDetailIframe,
      },
      {
        path: 'product/restock/detail-prev',
        name: 'RestockDetailPrev',
        component: RestockDetail,
      },
      {
        path: 'product/customProperty',
        name: 'ProductCustomPropertyIframe',
        component: ProductCustomPropertyIframe,
      },
      {
        path: 'product/management/custom-properties/edit',
        name: 'ProductCustomPropertyEditIframe',
        component: ProductCustomPropertyEditIframe,
      },
      {
        path: 'product/bulkImage',
        name: 'ProductBulkImageUpload',
        component: ProductBulkImageUpload,
      },
      {
        path: 'product/bulkImage/list',
        name: 'ProductBulkImageList',
        component: ProductBulkImageList,
      },
      {
        path: 'product/sticker/list',
        name: 'StickerList',
        component: StickerListIframe,
      },
      {
        path: 'product/recurring-payment/management-prev',
        name: 'RecurringPaymentsProductManagement',
        component: RecurringPaymentsProductManagement,
      },
      {
        path: 'product/recurring-payment/management',
        name: 'RecurringPaymentsProductManagement',
        component: RecurringPaymentsProductManagementIframe,
      },
      {
        path: 'product/recurring-payment/register-prev',
        name: 'RecurringPaymentsProductRegister',
        component: RecurringPaymentsProductRegister,
      },
      {
        path: 'product/recurring-payment/register',
        name: 'RecurringPaymentsProductRegister',
        component: RecurringPaymentsProductRegisterIframe,
      },
      {
        path: 'product/recurring-payment/edit',
        name: 'RecurringPaymentsProductRegister',
        component: RecurringPaymentsProductRegisterIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list-prev',
        name: 'OrderList',
        component: OrderList,
        meta: {
          historyName: 'ORDER_TOTAL',
          // 주문관리 > 전체주문 조회
          excelCreateMenuKey: 'PREMIUM_ORDER_LIST_BY_ORDER_NO',
        },
      },
      {
        path: 'order/list',
        name: 'OrderListIframe',
        component: OrderListIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/deposit-wait-prev',
        name: 'OrderListDeposit',
        component: OrderDeposit,
        meta: {
          historyName: 'ORDER_DEPOSIT_WAIT',
          // 주문관리 > 입금대기 주문
          excelCreateMenuKey: 'PREMIUM_DEPOSIT_WAIT',
        },
      },
      {
        path: 'order/list/deposit-wait',
        name: 'OrderDepositWaitIframe',
        component: OrderDepositWaitIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/pay-done-prev',
        name: 'OrderPayDone',
        component: OrderPayDone,
        meta: {
          historyName: 'ORDER_PAY_DONE',
          // 주문관리 > 결제완료 주문
          excelCreateMenuKey: 'PREMIUM_PAY_DONE',
        },
      },
      {
        path: 'order/list/pay-done',
        name: 'OrderPayDoneIframe',
        component: OrderPayDoneIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/product-prepare-prev',
        name: 'OrderProductPrepare',
        component: OrderProductPrepare,
        meta: {
          historyName: 'ORDER_PRODUCT_PREPARE',
          // 주문관리 > 상품준비중 주문
          excelCreateMenuKey: 'PREMIUM_PRODUCT_PREPARE',
        },
      },
      {
        path: 'order/list/product-prepare',
        name: 'OrderProductPrepareIframe',
        component: OrderProductPrepareIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/delivery-prepare-prev',
        name: 'DeliveryPrepare',
        component: DeliveryPrepare,
        // 주문관리 > 배송준비중 주문
        meta: {
          excelCreateMenuKey: 'PREMIUM_DELIVERY_PREPARE',
        },
      },
      {
        path: 'order/list/delivery-prepare',
        name: 'DeliveryPrepareIframe',
        component: DeliveryPrepareIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/delivery-ing-prev',
        name: 'OrderDeliverying',
        component: OrderDeliverying,
        meta: {
          historyName: 'ORDER_DELIVERY_ING',
          // 주문관리 > 배송중 주문
          excelCreateMenuKey: 'PREMIUM_DELIVERY_ING',
        },
      },
      {
        path: 'order/list/delivery-ing',
        name: 'OrderDeliveringIframe',
        component: OrderDeliveringIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/delivery-done-prev',
        name: 'OrderDeliveryDone',
        component: OrderDeliveryDone,
        meta: {
          historyName: 'ORDER_DELIVERY_DONE',
          // 주문관리 > 배송완료 주문
          excelCreateMenuKey: 'PREMIUM_DELIVERY_DONE',
        },
      },
      {
        path: 'order/list/delivery-done',
        name: 'OrderDeliveryDoneIframe',
        component: OrderDeliveryDoneIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/buy-confirm-prev',
        name: 'OrderBuyConfirm',
        component: OrderBuyConfirm,
        meta: {
          historyName: 'ORDER_BUY_CONFIRM',
          // 주문관리 > 구매확정 주문
          excelCreateMenuKey: 'PREMIUM_BUY_CONFIRM',
        },
      },
      {
        path: 'order/list/buy-confirm',
        name: 'OrderBuyConfirmIframe',
        component: OrderBuyConfirmIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/pay-fail-prev',
        name: 'OrderPayFail',
        component: OrderPayFail,
        meta: {
          historyName: 'ORDER_PAY_FAIL',
          // 주문관리 > 결제실패 주문
          excelCreateMenuKey: 'PREMIUM_PAY_FAIL',
        },
      },
      {
        path: 'order/list/pay-fail',
        name: 'OrderPayFailIframe',
        component: OrderPayFailIframe,
      },
      // FIXME - 리얼 반영 전 제거
      {
        path: 'order/list/holdDelivery-prev',
        name: 'OrderHoldDelivery',
        component: OrderHoldDelivery,
        meta: {
          historyName: 'ORDER_HOLD_DELIVERY',
          // 주문관리 > 배송보류 관리
          excelCreateMenuKey: 'PREMIUM_HOLD_DELIVERY',
        },
      },
      {
        path: 'order/list/holdDelivery',
        name: 'OrderHoldDeliveryIframe',
        component: OrderHoldDeliveryIframe,
      },
      // FIXME - 리얼 반영 전 삭제
      {
        path: 'order/list/holdByReservation-prev',
        name: 'OrderHoldByReservation',
        component: OrderHoldByReservation,
        meta: {
          // 주문관리 > 예약주문 관리
          excelCreateMenuKey: 'PREMIUM_RESERVATION_ORDER',
        },
      },
      {
        path: 'order/list/holdByReservation',
        name: 'OrderHoldByReservationIframe',
        component: OrderHoldByReservationIframe,
      },
      {
        path: 'order/subscription-change-notification/:action',
        name: 'SubscriptionChangeNotificationIframe',
        component: SubscriptionChangeNotificationIframe,
      },
      // FIXME - 리얼 반영 전 삭제
      {
        path: 'order/list/recurring-payments-prev',
        name: 'OrderRecurringPayments',
        component: OrderRecurringPayments,
      },
      {
        path: 'order/list/recurring-payments',
        name: 'RecurringPaymentsIframe',
        component: RecurringPaymentsIframe,
      },
      {
        path: '/order/list/previous-orders',
        name: 'PreviousOrdersIframe',
        component: PreviousOrdersIframe,
      },
      {
        path: 'order/list/inactive-member-order',
        name: 'InactiveMemberOrderIframe',
        component: InactiveMemberOrderIframe,
      },
      {
        path: 'order/manual-order',
        name: 'ManualOrder',
        component: ManualOrder,
      },
      {
        path: 'order/detail',
        name: 'OrderDetail',
        component: OrderDetailIframe,
      },
      {
        path: 'order/detail-prev',
        name: 'OrderDetail',
        component: OrderDetail,
      },
      {
        path: 'order/previous-detail',
        name: 'OrderPreviousDetailIframe',
        component: OrderPreviousDetailIframe,
      },
      {
        path: 'order/manual-order/confirm',
        name: 'ManualConfirm',
        component: ManualConfirm,
      },
      // 클레임관리
      // FIXME - 리얼 반영 전 삭제
      {
        path: 'claim/list/cancel-prev',
        name: 'CancelList',
        component: CancelList,
        meta: {
          historyName: 'CLAIM_CANCEL',
          // 클레임관리 > 취소 관리
          excelCreateMenuKey: 'PREMIUM_CANCEL_LIST',
        },
      },
      {
        path: 'claim/list/cancel',
        name: 'CancelIframe',
        component: CancelIframe,
      },
      // FIXME - 리얼 반영 전 삭제
      {
        path: 'claim/list/exchange-prev',
        name: 'ExchangeList',
        component: ExchangeList,
        meta: {
          historyName: 'CLAIM_EXCHANGE',
          // 클레임관리 > 교환 관리
          excelCreateMenuKey: 'PREMIUM_EXCHANGE_LIST',
        },
      },
      {
        path: 'claim/list/exchange',
        name: 'ExchangeIframe',
        component: ExchangeIframe,
      },
      // FIXME - 리얼 반영 전 삭제
      {
        path: 'claim/list/return-prev',
        name: 'ReturnList',
        component: ReturnList,
        meta: {
          historyName: 'CLAIM_RETURN',
          // 클레임관리 > 반품 관리
          excelCreateMenuKey: 'PREMIUM_RETURN_LIST',
        },
      },
      {
        path: 'claim/list/return',
        name: 'ReturnIframe',
        component: ReturnIframe,
      },
      // FIXME - 리얼 반영 전 삭제
      {
        path: 'claim/list/refund-prev',
        name: 'RefundsList',
        component: RefundsList,
        meta: {
          historyName: 'CLAIM_REFUND',
          // 클레임관리 > 환불 관리
          excelCreateMenuKey: 'PREMIUM_REFUND_LIST',
        },
      },
      {
        path: 'claim/list/refund',
        name: 'RefundIframe',
        component: RefundIframe,
      },
      // FIXME - 리얼 반영 전 삭제
      {
        path: 'claim/cs/list-prev',
        name: 'CsList',
        component: CsList,
        meta: {
          historyName: 'CLAIM_CS_HISTORY',
        },
      },
      {
        path: 'claim/cs/list',
        name: 'CsLogIframe',
        component: CsLogIframe,
      },
      // FIXME - 리얼 반영 전 삭제
      {
        path: 'claim/list/message-prev',
        name: 'MessageList',
        component: MessageList,
        meta: {
          excelCreateMenuKey: 'PREMIUM_MESSAGE_LIST',
        },
      },
      {
        path: 'claim/list/message',
        name: 'TaskMessageIframe',
        component: TaskMessageIframe,
      },
      // 회원관리
      {
        path: 'member/list',
        name: 'MemberList',
        component: MemberListIframe,
      },
      {
        path: 'member/register',
        name: 'MemberRegister',
        component: MemberRegisterIframe,
      },
      {
        path: 'member/edit',
        name: 'MemberEditIframe',
        component: MemberEditIframe,
      },
      // {
      //   path: 'member/grade',
      //   name: 'MemberGrade',
      //   component: MemberGrade,
      // },
      {
        path: 'member/grade',
        name: 'MemberGradeIframe',
        component: MemberGradeIframe,
      },
      {
        path: 'member/group',
        name: 'Group',
        component: MemberGroup,
        // Error 입력값이 잘못되었습니다. 필드명 : menu
        // meta: {
        //   title: '회원그룹 관리',
        //   historyName: 'MEMBER_GROUP'
        // }
      },
      {
        path: 'member/freeze',
        name: 'DormantMemberIframe',
        component: DormantMemberIframe,
      },
      {
        path: 'member/expel',
        name: 'WithdrawalMemberIframe',
        component: WithdrawalMemberIframe,
        // meta: {
        //   historyName: 'MEMBER_EXPEL',
        // },
      },
      {
        path: 'member/collection-setting',
        name: 'CollectionSettingIframe',
        component: CollectionSettingIframe,
        meta: {
          title: '회원가입 항목 관리',
        },
      },
      // 기획전 관리
      {
        path: 'event/list',
        name: 'EventList',
        component: EventListIframe,
      },
      {
        path: 'event/addForm',
        name: 'EventAddForm',
        component: EventAddFormIframe,
      },
      {
        path: 'event/copy',
        name: 'EventCopy',
        component: EventAddFormIframe,
      },
      // 상품진열 관리
      {
        path: 'appearance/custom/product-main',
        name: 'ProductSection',
        component: ProductMainListIframe,
      },
      {
        path: 'appearance/custom/product-main/add',
        name: 'ProductSectionAdd',
        component: ProductMainAddIframe,
      },
      {
        path: 'appearance/custom/product-main/edit',
        name: 'ProductSectionEdit',
        component: ProductMainAddIframe,
      },
      {
        path: 'banner/list',
        name: 'BannerList',
        component: BannerList,
      },
      //경로가 조금 이상한데 나중에 통합할때 사용할 URL이라서 이렇게 씀
      {
        path: '/appearance/custom/headless-banners',
        name: 'HeadlessBanners',
        component: HeadlessBanners,
      },
      {
        path: '/appearance/custom/headless-banners/add',
        name: 'HeadlessBannersAdd',
        component: HeadlessBannersAdd,
      },
      {
        path: '/appearance/custom/headless-banners/edit',
        name: 'HeadlessBannersEdit',
        component: HeadlessBannersEdit,
      },
      {
        path: '/appearance/custom/skin-banners',
        name: 'SkinBanners',
        component: SkinBanners,
      },
      {
        path: '/appearance/custom/skin-banners/add',
        name: 'SkinBannersAdd',
        component: SkinBannersAdd,
      },
      {
        path: '/appearance/custom/skin-banners/edit',
        name: 'SkinBannersEdit',
        component: SkinBannersEdit,
      },
      {
        path: 'display/category-prev',
        name: 'DisplayCategoryPrev',
        component: DisplayCategory,
      },
      {
        path: 'display/category',
        name: 'DisplayCategory',
        component: DisplayCategoryIframe,
      },
      {
        path: 'display/display-priority',
        name: 'DisplayPriorityIframe',
        component: DisplayPriorityIframe,
      },
      {
        path: 'display/brand',
        name: 'BrandIframe',
        component: BrandIframe,
      },
      {
        path: 'popup/list',
        name: 'PopupList',
        component: PopupList,
      },
      {
        path: 'popup/add',
        name: 'PopupDetail',
        component: PopupDetail,
      },
      {
        path: 'product/priority-prev',
        name: 'ProductPriority',
        component: ProductPriority,
      },
      {
        path: 'product/priority',
        name: 'ProductPriorityIframe',
        component: ProductDisplayOrderIframe,
      },
      // 운영관리
      {
        path: 'inquiry-prev',
        name: 'InquiryListPrev',
        component: InquiryList,
        meta: {
          // 운영관리 > 1:1문의 관리 > 1:1문의 답변(탭)
          excelCreateMenuKey: 'PREMIUM_INQUIRY_LIST',
        },
      },
      {
        path: 'inquiry-prev/type',
        name: 'InquiryTypePrev',
        component: TypeConfig,
      },
      {
        path: 'inquiry-prev/template',
        name: 'InquiryTemplatePrev',
        component: InquiryTemplate,
        meta: {
          historyName: 'MANAGE_INQUIRY',
        },
      },
      {
        path: 'inquiry',
        name: 'InquiryList',
        redirect: { name: 'InquiryListIframe'},
        component: InquiryListIframe,
      },
      {
        path: 'inquiry/list',
        name: 'InquiryListIframe',
        component: InquiryListIframe,
        meta: {
          // 운영관리 > 1:1문의 관리 > 1:1문의 답변(탭)
          excelCreateMenuKey: 'PREMIUM_INQUIRY_LIST',
        },
      },
      {
        path: 'inquiry/category',
        name: 'InquiryCategory',
        component: InquiryListIframe,
      },
      {
        path: 'inquiry/template',
        name: 'InquiryTemplate',
        component: InquiryListIframe,
        meta: {
          historyName: 'MANAGE_INQUIRY',
        },
      },
      {
        path: 'inquiry/setting',
        name: 'InquirySetting',
        component: InquiryListIframe,
      },
      {
        path: 'board/article-prev',
        name: 'ArticleListPrev',
        component: ArticleList,
        meta: {
          historyName: 'MANAGE_BOARD_ARTICLE',
          // 운영관리 > 게시글 관리 > 게시글 엑셀 다운로드(버튼)
          // 운영관리 > 게시글 관리 > 전체 엑셀 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_ARTICLE_LIST',
        },
      },
      {
        path: 'board/article',
        name: 'ArticleList',
        component: ArticleListIframe,
        meta: {
          historyName: 'MANAGE_BOARD_ARTICLE',
          // 운영관리 > 게시글 관리 > 게시글 엑셀 다운로드(버튼)
          // 운영관리 > 게시글 관리 > 전체 엑셀 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_ARTICLE_LIST',
        },
      },
      {
        path: 'board-prev',
        name: 'BoardPrev',
        component: Boards,
      },
      {
        path: 'board',
        name: 'Board',
        component: BoardsIframe,
      },
      {
        path: 'accumulation/setting',
        name: 'AccumulationSettingIframe',
        component: AccumulationSettingIframe,
      },
      {
        path: 'accumulation/payment-deduct',
        name: 'AccumulationPaymentDeductIframe',
        component: AccumulationPaymentDeductIframe,
      },
      {
        path: 'accumulationConfiguration',
        name: 'AccumulationConfiguration',
        component: AccumulationConfiguration,
        meta: {
          historyName: 'MANAGE_BOARD_ACCUMULATION',
        },
      },
      {
        path: 'accumulationConfiguration/modify/:mallNo',
        name: 'AccumulationConfigurationModify',
        component: AccumulationConfigurationModify,
      },
      {
        path: 'accumulation/payment',
        name: 'AccumulationPayment',
        component: AccumulationPayment,
        meta: {
          // 운영관리 > 적립금 관리 > 적립금 지급관리(탭)
          // 운영관리 > 적립금 관리 > 적립금 지급관리(탭) > 조회결과 > 지급현황 > 적립금 지급현황(팝업)
          excelCreateMenuKey: 'PREMIUM_ACCUMULATION_LIST',
        },
      },
      {
        path: 'accumulation',
        name: 'AccumulationMain',
        component: AccumulationMain,
        meta: {
          // 운영관리 > 적립금 관리 > 적립금 적립/차감 조회(탭) > 일별 적립금 합계 > 그룹별 다운로드(버튼)
          // 운영관리 > 적립금 관리 > 적립금 적립/차감 조회(탭) > 일별 적립금 합계 > 등급별 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_ACCUMULATION_DAILY_GROUP',
        },
      },
      {
        path: 'accumulation/payment/request',
        name: 'PaymentRequestModify',
        component: PaymentRequestModify,
      },
      //NOTE : SMS 발송 -> 'SMS관리'메뉴 진입페이지
      {
        path: 'sms/dispatch',
        name: 'SmsDispatch',
        component: SmsDispatch,
      },
      {
        path: 'sms/send-list',
        name: 'SmsSendList',
        component: SmsSendList,
        meta: {
          historyName: 'MEMBER_SMS_HISTORY',
        },
      },
      // 메시지
      {
        path: 'member/message/*',
        name: 'MessageIframe',
        component: MessageIframe,
      },
      // 080 수신거부 관리
      {
        path: 'pro/premium/sms/reject/config', // 'pro/premium/sms/reject/config' path는 추후 BE팀이랑 일정 잡아서 변경될 예정. 아래 member/sms/reject, member/sms/reject/list 사용하면 될듯
        name: 'SmsRejectConfig',
        component: SmsRejectIframe,
        meta: {
          iframePath: '/member/sms/reject',
        },
      },
      {
        path: 'member/sms/reject',
        name: 'SmsRejectConfig',
        component: SmsRejectIframe,
        meta: {
          iframePath: '/member/sms/reject',
        },
      },
      {
        path: 'member/sms/reject/list',
        name: 'SmsRejectConfig',
        component: SmsRejectIframe,
        meta: {
          iframePath: '/member/sms/reject/list',
        },
      },
      {
        path: 'sms/usage-list',
        name: 'SmsUsageList',
        component: SmsUsageList,
      },
      //NOTE : 자동SMS 설정 미노출
      // {
      //   path: 'sms/autoSms',
      //   name: 'autoSms',
      //   component: SmsAuto,
      //   meta: {
      //     historyName: 'MEMBER_AUTO_SMS',
      //   },
      // },
      //NOTE : SMS 템플릿 설정 미노출
      // {
      //   path: 'sms/template-config',
      //   name: 'SmsTemplateConfig',
      //   component: SmsTemplateConfig,
      // },
      {
        path: 'mail/dispatch',
        name: 'MailIframe',
        component: MailIframe,
      },
      {
        path: 'mail/usage-list',
        name: 'MailUsageList',
        component: MailUsageList,
      },
      {
        path: 'mail/send-list',
        name: 'SendList',
        component: SendList,
      },
      {
        path: 'mail/template-config',
        name: 'TemplateConfig',
        component: TemplateConfig,
        meta: {
          historyName: 'MEMBER_EMAIL_CONFIG',
        },
      },
      {
        path: 'mail/autoMail',
        name: 'AutoMail',
        component: AutoMail,
        meta: {
          historyName: 'MEMBER_AUTO_EMAIL',
        },
      },

      // 프로모션관리
      {
        // 추가할인관리(조회)
        path: 'promotion/discount', // PRO 와 다름
        name: 'PromotionDiscount',
        // component: DiscountView,
        component: AdditionalDiscountManagementIframe,
      },

      {
        // 추가할인등록
        path: 'promotion/additional-discount/management/registration', // PRO 와 동일
        name: 'AdditionalDiscountRegistration',
        component: AdditionalDiscountRegistrationIframe,
      },

      {
        // 추가할인 수정
        path: 'promotion/additional-discount/management/modification', // PRO 와 동일
        name: 'AdditionalDiscountModification',
        component: AdditionalDiscountModificationIframe,
      },

      // {
      //   path: 'promotion/discount/add',
      //   name: 'DiscountAddForm',
      //   component: DiscountAddForm,
      // },
      // {
      //   path: 'promotion/discount/modify',
      //   name: 'DiscountModify',
      //   component: DiscountAddForm,
      // },
      {
        path: 'promotion/coupon/list',
        name: 'CouponList',
        // component: CouponList,
        component: CouponIssueIframe,
        meta: {
          // 프로모션관리 > 할인쿠폰 관리 > 할인쿠폰 발행 관리(탭)
          // 프로모션관리 > 할인쿠폰 관리 > 할인쿠폰 발행 관리(탭) > 조회결과 > 사용현황 > 할인쿠폰 사용현황(팝업)
          excelCreateMenuKey: 'PREMIUM_COUPON_LIST',
        },
      },
      {
        path: 'promotion/coupon/issue-plan/modifyForm',
        name: 'IssuePlanModifyForm',
        component: IssuePlanAddForm,
      },
      {
        path: 'promotion/coupon/modifyForm',
        name: 'EditCoupon',
        component: CouponIssueIframe,
        // component: CouponDetail,
        meta: {
          detailPath: '/modify?',
        },
      },
      {
        path: 'promotion/coupon/addForm',
        name: 'AddCoupon',
        component: CouponIssueIframe,
        // component: CouponDetail,
        meta: {
          detailPath: '/add?',
        },
      },
      {
        path: 'promotion/coupon/addForm',
        name: 'CopyCoupon',
        component: CouponIssueIframe,
        meta: {
          detailPath: '/copy?',
        },
      },
      {
        path: 'promotion/coupon/issue-plan/addForm',
        name: 'IssuePlanAddForm',
        component: IssuePlanAddForm,
      },
      {
        path: 'promotion/coupon/issue-plan/list',
        name: 'CouponIssuePlanList',
        component: CouponIssuePlanListIframe,
        // component: CouponIssuePlanList,
        meta: {
          // 프로모션관리 > 할인쿠폰 관리 > 할인쿠폰 지급 관리(탭)
          // 프로모션관리 > 할인쿠폰 관리 > 할인쿠폰 지급 관리(탭) > 할인쿠폰 지급현황(팝업)
          excelCreateMenuKey: 'PREMIUM_COUPON_ISSUE_PLAN_LIST',
        },
      },
      {
        path: 'promotion/coupon-setting',
        name: 'CouponSettingIframe',
        component: CouponSettingIframe,
      },
      // 프로모션관리 > 사은품관리
      {
        path: '/promotion/free-gift',
        name: 'FreeGiftContainer',
        component: FreeGiftContainer,
        redirect: { name: 'FreeGiftConfiguration' },
        children: [
          {
            path: 'configuration',
            name: 'FreeGiftConfiguration',
            component: FreeGiftConfigurationIframe,
          },
          {
            path: 'condition',
            name: 'FreeGiftCondition',
            component: FreeGiftConditionIframe,
            meta: {
              excelCreateMenuKey: 'PREMIUM_FREE_GIFT_CONDITION_LIST',
              tab: 'condition',
            },
          },
        ],
      },
      {
        path: '/promotion/free-gift/condition/add',
        name: 'ConditionRegistration',
        component: ConditionRegistrationIframe,
        meta: {
          mode: 'register',
        },
      },
      {
        path: '/promotion/free-gift/condition/edit/:conditionNo',
        name: 'ConditionRegistration',
        component: ConditionRegistrationIframe,
        meta: {
          mode: 'edit',
        },
      },
      {
        path: '/promotion/option/search/popup',
        name: 'PromotionOptionPopSearch',
        component: PromotionOptionPopSearch,
      },
      // 파트너관리
      {
        path: 'partner/list-prev',
        name: 'PartnerListPrev',
        component: PartnerList,
      },
      {
        path: 'partner/list',
        name: 'PartnerList',
        component: PartnerListIframe,
      },
      {
        path: 'partner/modification-prev/:partnerNo',
        name: 'PartnerEditPagePrev',
        component: PartnerEditPage,
      },
      {
        path: 'partner/modification/:partnerNo',
        name: 'PartnerEditPage',
        component: PartnerEditPageIframe,
      },
      {
        path: 'partner/register-prev',
        name: 'PartnerRegisterPrev',
        component: PartnerRegister,
      },
      {
        path: 'partner/register',
        name: 'PartnerRegister',
        component: PartnerRegisterIframe,
      },
      {
        path: 'partner/contract-prev',
        name: 'PartnerContractPrev',
        component: PartnerContract,
      },
      {
        path: 'partner/contract',
        name: 'PartnerContract',
        component: PartnerContractIframe,
      },
      {
        path: 'partner/copy-prev',
        name: 'PartnerCopyPrev',
        component: PartnerCopy,
      },
      {
        path: 'partner/copy',
        name: 'PartnerCopy',
        component: PartnerCopyIframe,
      },
      {
        path: 'partner/pool/copy',
        name: 'PartnerPoolCopy',
        component: PartnerPool,
      },
      {
        path: 'partner/new-prev',
        name: 'PartnerNewPrev',
        component: PartnerNew,
      },
      {
        path: 'partner/new',
        name: 'PartnerNew',
        component: PartnerNewIframe,
      },
      {
        path: 'partner/pool/contract',
        name: 'PartnerPoolContract',
        component: PartnerPool,
      },
      {
        path: 'board/notice',
        name: 'NoticeListIframe',
        component: NoticeListIframe,
      },
      {
        path: 'settlement/partner-prev',
        name: 'SettlementPartnerPrev',
        component: SettlementPartner,
        meta: {
          // 파트너관리 > 매출 내역 조회 > 매출 합계 > 상세보기 > 다운로드(버튼)
          // 파트너관리 > 매출 내역 조회 > 일별 매출 상세 > 상세보기 > 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_SETTLEMENT_TOTAL_SALE',
        },
      },
      {
        path: '/configuration/partner/operation-group',
        name: 'OperationGroupList',
        component: OperationGroupListIframe,
      },
      {
        path: '/configuration/partner/operation-group/add',
        name: 'OperationGroupAdd',
        component: OperationGroupAddIframe,
      },
      {
        path: '/configuration/partner/operation-group/edit',
        name: 'OperationGroupEdit',
        component: OperationGroupEditIframe,
      },
      {
        path: 'settlement/partner',
        name: 'SettlementPartner',
        component: SettlementPartnerIframe,
      },
      {
        path: 'settlement/list-prev',
        name: 'SettlementListPrev',
        component: SettlementList,
        meta: {
          // 파트너관리 > 정산 현황 조회 > 정산예상금액 상세 > 파트너별 다운로드(버튼)
          // 파트너관리 > 정산 현황 조회 > 정산예상금액 상세 > 옵션별 다운로드(버튼)
          // 파트너관리 > 정산 현황 조회 > 정산예상금액 상세 > 상세보기 > 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_SETTLEMENT_BY_PARTNER',
        },
      },
      {
        path: 'settlement/list',
        name: 'SettlementList',
        component: SettlementListIframe,
      },
      // 서비스관리
      {
        path: 'mall/list',
        name: 'MallList',
        component: MallList,
      },
      {
        path: 'mall/modification/:id',
        name: 'MallEditForm',
        component: MallForm,
      },
      {
        path: 'mall/addForm',
        name: 'MallAddForm',
        component: MallAddForm,
      },
      {
        path: 'authorityGroup/list-prev',
        name: 'GroupListPrev',
        component: GroupList,
        meta: {
          historyName: 'AUTHORITY_MANAGE',
        },
      },
      {
        path: 'authorityGroup/list',
        name: 'GroupList',
        component: GroupListIframe,
        meta: {
          historyName: 'AUTHORITY_MANAGE',
        },
      },
      {
        path: 'authorityGroup/addForm-prev',
        name: 'GroupAddFormPrev',
        component: GroupAddForm,
        meta: {
          historyName: 'AUTHORITY_ADD',
        },
      },
      {
        path: 'authorityGroup/addForm',
        name: 'GroupAddForm',
        component: GroupAddFormIframe,
        meta: {
          historyName: 'AUTHORITY_ADD',
        },
      },
      {
        path: 'authorityGroup/modifyForm-prev/:authorityGroupNo',
        name: 'modifyFormPrev',
        component: GroupAddForm,
        meta: {
          historyName: 'AUTHORITY_CHANGE',
        },
      },
      {
        path: 'authorityGroup/modifyForm/:authorityGroupNo',
        name: 'modifyForm',
        component: GroupAddFormIframe,
        meta: {
          historyName: 'AUTHORITY_CHANGE',
        },
      },
      {
        path: 'admin/list-prev',
        name: 'AdminList',
        component: AdminList,
        meta: {
          historyName: 'ADMIN_MANAGE',
        },
      },
      {
        path: 'admin/list',
        name: 'AdminListIframe',
        component: AdminListIframe,
      },
      {
        path: 'admin/new-prev',
        name: 'AdminAddPrev',
        component: AdminAdd,
        meta: {
          historyName: 'ADMIN_ADD',
        },
      },
      {
        path: 'admin/new',
        name: 'AdminAdd',
        component: AdminAddIframe,
        meta: {
          historyName: 'ADMIN_ADD',
        },
      },
      {
        path: 'admin/modification-prev/:adminNo',
        name: 'AdminEdit',
        component: AdminEdit,
        meta: {
          historyName: 'ADMIN_CHANGE',
        },
      },
      {
        path: 'admin/modification/:adminNo',
        name: 'AdminEditIframe',
        component: AdminEditIframe,
      },
      {
        path: 'admin/department',
        component: AdminDepartment,
        children: [
          {
            path: '',
            name: 'ChildAdminDepartment',
            component: ChildAdminDepartment,
          },
          {
            path: 'jobduty',
            name: 'Jobduty',
            component: Jobduty,
          },
        ],
      },
      {
        path: 'admin/role/:role',
        component: AdminListIframe,
      },
      {
        path: 'service-prev',
        name: 'ServiceInfoPrev',
        component: ServiceInfoPrev,
        meta: {
          historyName: 'CONFIGURATION_DETAIL',
        },
      },
      {
        path: 'service',
        name: 'ServiceInfo',
        component: ServiceInfoIframe,
        meta: {
          historyName: 'CONFIGURATION_DETAIL',
        },
      },
      {
        path: 'admin/security-setting',
        name: 'SecuritySetting',
        component: SecuritySetting,
      },
      {
        path: 'domain-ssl',
        name: 'DomainSslIframe',
        component: DomainSslIframe,
      },
      {
        path: 'domain-detail/:domainNo',
        name: 'DomainDetailIframe',
        component: DomainDetailIframe,
      },
      {
        path: 'ssl-detail/:domainNo',
        name: 'SslDetailIframe',
        component: SslDetailIframe,
      },
      {
        path: 'pg',
        name: 'PgConfigIframe',
        component: PgConfigIframe,
      },
      {
        path: 'payco-config',
        name: 'PaycoConfigIframe',
        component: PaycoConfigIframe,
      },
      {
        path: 'naverpay-config',
        name: 'NaverPayConfigIframe',
        component: NaverPayConfigIframe,
      },
      {
        path: 'toss-payment-config',
        name: 'TossPaymentConfigIframe',
        component: TossPaymentConfigIframe,
      },
      {
        path: '/configuration/payment/order-extra-config',
        name: 'OrderExtraConfigIframe',
        component: OrderExtraConfigIframe,
      },
      {
        path: 'settlement-adjustment-list',
        name: 'SettlementAdjustmentList',
        component: SettlementAdjustmentList,
      },
      {
        path: 'settlement-adjustment-detail',
        name: 'SettlementAdjustmentDetail',
        component: SettlementAdjustmentDetail,
      },
      {
        path: 'naver-shopping-config',
        name: 'NaverShoppingConfigIframe',
        component: NaverShoppingConfigIframe,
      },
      {
        path: 'privacyAccessHistoriesPrev',
        name: 'PrivacyAccessHistoriesPrev',
        component: PrivacyAccessHistories,
        meta: {
          excelCreateMenuKey: 'PREMIUM_SERVICE_PRIVACY_HISTORIES',
        },
      },
      {
        path: 'privacyAccessHistories',
        name: 'PrivacyAccessHistories',
        component: PrivacyAccessHistoriesIframe,
      },
      {
        path: 'terms/tab/introduction',
        name: 'TermsIframe',
        component: TermsIframe,
      },
      {
        path: 'terms/tab/introduction-prev',
        name: 'Introduction',
        component: Introduction,
      },
      {
        path: 'terms/tab/e-commerce',
        name: 'TermsIframe',
        component: TermsIframe,
      },
      {
        path: 'terms/tab/e-commerce-prev',
        name: 'E-commerce', //do not change it's format
        component: Ecommerce,
      },
      {
        path: 'terms/tab/collection',
        name: 'TermsIframe',
        component: TermsIframe,
      },
      {
        path: 'terms/tab/collection-prev',
        name: 'Collection',
        component: Collection,
      },
      {
        path: 'terms/tab/withdrawal',
        name: 'TermsIframe',
        component: TermsIframe,
      },
      {
        path: 'terms/tab/withdrawal-prev',
        name: 'Withdrawal',
        component: Withdrawal,
      },
      {
        path: 'terms/tab/access',
        name: 'TermsIframe',
        component: TermsIframe,
      },
      {
        path: 'terms/tab/access-prev',
        name: 'Access',
        component: Access,
      },
      {
        path: 'terms/tab/personal-info',
        name: 'TermsIframe', //do not change it's format
        component: TermsIframe,
      },
      {
        path: 'terms/tab/personal-info-prev',
        name: 'Personal-Info', //do not change it's format
        component: PersonalInfo,
      },
      {
        path: 'board/notice/service',
        name: 'NoticeService',
        component: NoticeService,
      },
      {
        path: 'board/faq',
        name: 'FaqList',
        component: FaqList,
      },
      {
        path: 'external',
        name: 'ExternalService',
        component: ExternalServiceIframe,
      },
      // 회원통계
      {
        path: 'statistic/member/period',
        name: 'MemberPeriod',
        component: MemberPeriodIframe,
      },
      {
        path: 'statistic/member/period-prev',
        name: 'MemberPeriodPrev',
        component: MemberPeriod,
        meta: {
          historyName: 'STATISTICS_SALES_PERIOD',
        },
      },
      {
        path: 'statistic/sales/period',
        name: 'SalesPeriodIframe',
        component: SalesPeriodIframe,
      },
      {
        path: 'statistic/sales/product',
        name: 'SalesProductIframe',
        component: SalesPeriodIframe,
      },
      {
        path: 'statistic/sales/category',
        name: 'SalesCategoryIframe',
        component: SalesPeriodIframe,
      },
      {
        path: 'statistic/sales/period-prev',
        name: 'SalesPeriod',
        component: SalesPeriod,
        meta: {
          historyName: 'STATISTICS_SALES_PERIOD',
          // 통계 > 판매통계 > 기간별 판매현황(탭) > 기간별 판매현황 종합 > 상세보기 > 다운로드(버튼)
          // 통계 > 판매통계 > 기간별 판매현황(탭) > 일자별 판매현황 > 상세보기 > 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_STATISTICS_SALE_PERIOD',
        },
      },
      {
        path: 'statistic/sales/product-prev',
        name: 'SalesProduct',
        component: SalesProduct,
        meta: {
          historyName: 'STATISTICS_SALES_PRODUCT',
          // 통계 > 판매통계 > 상품 판매현황(탭) > 기간별 상품 판매현황 종합 > 상세보기 > 다운로드(버튼)
          // 통계 > 판매통계 > 상품 판매현황(탭) > 상품 세부판매현황 > 상세보기 > 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_STATISTICS_SALE_PRODUCT_PERIOD',
        },
      },
      {
        path: 'statistic/sales/category-prev',
        name: 'SalesCategory',
        component: SalesCategory,
        meta: {
          historyName: 'STATISTICS_SALES_CATEGORY',
          // 통계 > 판매통계 > 카테고리 판매현황(탭) > 기간별 카테고리 판매현황 종합 > 상세보기 > 다운로드(버튼)
          // 통계 > 판매통계 > 카테고리 판매현황(탭) > 카테고리 세부판매현황 > 상세보기 > 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_STATISTICS_SALE_CATEGORY_PERIOD',
        },
      },
      {
        path: 'statistic/promotion/additionalDiscount',
        name: 'StatisticDiscount',
        component: StatisticPromotionAdditionalDiscount,
        meta: {
          historyName: 'STATISTICS_PROMOTION_DISCOUNT',
        },
      },
      {
        path: 'statistic/promotion/coupon',
        name: 'StatisticCoupon',
        component: StatisticPromotionCouponIframe,
        meta: {
          historyName: 'STATISTICS_PROMOTION_COUPON',
        },
      },
      {
        path: 'statistic/promotion/additionalDiscount-prev',
        name: 'StatisticDiscountPrev',
        component: StatisticDiscount,
        meta: {
          historyName: 'STATISTICS_PROMOTION_DISCOUNT',
          // 통계 > 프로모션통계 > 추가할인 판매현황(탭) > 추가할인 판매현황 종합 > 상세보기 > 다운로드(버튼)
          // 통계 > 프로모션통계 > 추가할인 판매현황(탭) > 추가할인세부 판매현황 > 상세보기 > 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_STATISTICS_PROMOTION_ADDITIONAL_DISCOUNT',
        },
      },
      {
        path: 'statistic/promotion/coupon-prev',
        name: 'StatisticCouponPrev',
        component: StatisticCoupon,
        meta: {
          historyName: 'STATISTICS_PROMOTION_COUPON',
          // 통계 > 프로모션통계 > 할인쿠폰 판매현황(탭) > 할인쿠폰 판매현황 종합 > 상세보기 > 다운로드(버튼)
          // 통계 > 프로모션통계 > 할인쿠폰 판매현황(탭) > 할인쿠폰세부 판매현황 > 상세보기 > 다운로드(버튼)
          excelCreateMenuKey: 'PREMIUM_STATISTICS_PROMOTION_COUPON',
        },
      },
      // 정산관리
      {
        path: 'feepolicy/feeList',
        name: 'FeePolicyList',
        component: FeePolicyIframe,
      },

      // aggregator
      {
        path: '/member/crm-group/list',
        name: 'CrmGroupList',
        component: CrmGroupList,
      },
      {
        path: '/member/crm-group/create',
        name: 'CrmGroupCreate',
        component: CrmGroupCreate,
      },
    ],
  },
  // Common root Popup
  {
    path: '',
    component: PopupView,
    children: [
      // 상품관리
      {
        path: 'review/:reviewNo(\\d+)',
        name: 'ReviewDetailIframe',
        component: ReviewDetailIframe,
      },
      {
        path: 'review/changeDisplayStatus',
        name: 'ChangeDisplayStatus',
        component: ChangeDisplayStatus,
      },
      {
        path: 'review/changeBestReview',
        name: 'ChangeBestReview',
        component: ChangeBestReview,
      },
      {
        path: 'review/report/:reportNo(\\d+)',
        name: 'ReportDetail',
        component: ReportDetail,
      },
      {
        path: 'deliveryAreaFee/addForm',
        name: 'DeliveryAreaFeeAdd',
        component: DeliveryAreaFeeAddForm,
      },
      {
        path: 'deliveryAreaFee/modifyForm-prev',
        name: 'DeliveryAreaFeeModify',
        component: DeliveryAreaFeeModifyForm,
      },
      {
        path: 'deliveryAreaFee/modifyForm',
        name: 'DeliveryAreaFeeModify',
        component: DeliveryAreaFeeModifyFormIframe,
      },
      {
        path: 'warehouse/addForm',
        name: 'DeliveryWarehouseAdd',
        component: DeliveryWarehouseAddForm,
      },
      {
        path: 'delivery/modifyPopup',
        name: 'DeliveryModifyPopup',
        component: ModifyPopup,
      },
      {
        path: 'product/stock/modifyPopup',
        name: 'StockModify',
        component: StockModify,
      },
      {
        path: 'product/stock/excelUploadPopup',
        name: 'StockExcelUpload',
        component: StockExcelUpload,
      },
      {
        path: 'product/restock/popup',
        name: 'RestockSMSPopup',
        component: RestockSms,
      },
      {
        path: 'popup/display-category-excel-batch-register',
        name: 'DisplayCategoryExcelBatchRegisterIframe',
        component: DisplayCategoryExcelBatchRegisterIframe,
      },
      {
        path: 'popup/sms-send',
        name: 'RestockSMSSendPopup',
        component: RestockSmsSendIframe,
      },
      {
        path: 'product/bulkImage/uploadInfo',
        name: 'ProductBulkImageUploadGuide',
        component: ProductBulkImageUploadGuide,
      },
      {
        path: 'product/sticker/popup/add/:mallNo',
        name: 'ProductStickerAdd',
        component: ProductStickerAddForm,
      },
      {
        path: 'product/sticker/popup/modification/:mallNo/:stickerNo',
        name: 'ProductStickerModify',
        component: ProductStickerAddForm,
      },

      {
        path: 'productDuty/addForm',
        name: 'ProductDutyAdd',
        component: ProductDutyAddForm,
      },
      {
        path: 'productDuty/modifyForm',
        name: 'ProductDutyAdd',
        component: ProductDutyAddForm,
      },
      {
        path: 'productDuty/readForm',
        name: 'readForm',
        component: ProductDutyAddForm,
      },
      {
        path: 'productDuty/readFormForAgreement',
        name: 'readFormForAgreement',
        component: ProductDutyAddForm,
      },
      {
        path: 'option/addForm',
        name: 'OptionAdd',
        component: ProductOptionAddForm,
      },
      {
        path: 'option/otherOptionLoad',
        name: 'OptionLoad',
        component: OtherOptionLoad,
      },
      {
        path: 'option/image/addForm',
        name: 'OptionImageAdd',
        component: ProductOptionImageAddForm,
      },
      {
        path: 'option/image/batch/addForm',
        name: 'OptionImageBatchAdd',
        component: ProductOptionImageBatchAddForm,
      },
      {
        path: 'setProduct/addOptionForm',
        name: 'SetProduct',
        component: SetProduct,
      },
      {
        path: 'certification/addForm',
        name: 'CertificationAdd',
        component: CertificationAddForm,
      },
      {
        path: 'certification/readFormForAgreement',
        name: 'CertificationRead',
        component: CertificationAddForm,
      },
      {
        path: 'deliveryCondition/detailPopup',
        name: 'DeliveryDetailPopup',
        component: DeliveryConditionDetailPopup,
      },
      {
        path: 'deliveryTemplate/addForm',
        name: 'DeliveryTemplateAdd',
        component: DeliveryTemplateAddForm,
      },
      {
        path: 'product/recurring-payment/popup/change-opt', // url 글자수 제한(45자)로 인해 많이 줄여진 상태
        name: 'RecurringPaymentsProductSettingChange',
        component: RecurringPaymentsProductSettingChange,
      },
      // 주문관리
      {
        path: 'order/manual-order/popup/coupon/:theOrderSheetNo',
        name: 'ManualCoupon',
        component: ManualCoupon,
      },
      {
        path: 'order/delayProductOrderPopup',
        name: 'DelayProductOrderPopup',
        component: DelayProductOrderPopup,
      },
      // 클레임관리
      {
        path: 'claim/viewPopup',
        name: 'ViewPopup',
        component: ViewPopup,
      },
      {
        path: 'claim/collectReturnPopup',
        name: 'CollectReturnPopup',
        component: CollectReturnPopup,
      },
      // 회원관리
      {
        path: 'member/popup/grade',
        name: 'MemberGradeUpdate',
        component: MemberGradeUpdate,
      },
      {
        path: 'member/popup/group',
        name: 'MemberGroupUpdate',
        component: MemberGroupUpdate,
      },
      {
        path: 'member/popup/accumulate',
        name: 'MemberAccumulate',
        component: MemberAccumulate,
      },
      {
        path: 'member/popup/giveCoupon',
        name: 'MemberGiveCoupon',
        component: MemberGiveCoupon,
      },
      {
        path: 'member/popup/groups',
        name: 'MemberGroupList',
        component: MemberGroupList,
      },
      {
        path: 'member/target/popup',
        name: 'MemberTarget',
        component: MemberTarget,
      },
      {
        path: 'member/popup/memberGradeEvaluation/:mallNo(\\d+)',
        name: 'MemberGradeEvaluation',
        component: MemberGradeEvaluation,
      },
      {
        path: 'member/list/popup/:mallNo',
        name: 'MemberPopList',
        component: MemberPopList,
        meta: {
          historyName: 'POPUP_MEMBER_SEARCH',
        },
      },
      {
        path: 'member/popup/recipient',
        name: 'Recipient',
        component: Recipient,
      },
      {
        path: 'member/popup/giveCouponByGrade',
        name: 'MemberGiveCouponByGrade',
        component: MemberGiveCoupon,
      },
      {
        path: 'member/popup/expelMember',
        name: 'expelMember',
        component: ExpelMember,
      },
      {
        path: 'member/popup/withdrawCoupon',
        name: 'withdrawCoupon',
        component: WithdrawCoupon,
      },
      {
        path: 'member/popup/prohibitMember',
        name: 'ProhibitMember',
        component: ProhibitMember,
      },
      {
        path: 'member/popup/temporaryPassword',
        name: 'TemporaryPassword',
        component: TemporaryPassword,
      },
      {
        path: 'member/popup/crm/:memberId',
        component: MemberCrmIframe,
      },
      {
        path: 'member/popup/member-search',
        name: 'MemberSearch',
        component: MemberSearchIframe,
      },
      // 전시관리
      {
        path: 'event/popup/couponGuide',
        name: 'PopupCouponGuide',
        component: PopupCouponGuide,
      },
      {
        path: 'event/popup/searchCoupon',
        name: 'PopSearchCoupon',
        component: PopSearchCoupon,
      },
      // 운영관리
      {
        path: 'popup/excel-batch-registration',
        name: 'ExcelBatchRegistrationPopup',
        component: ExcelBatchRegistrationPopup,
      },
      {
        path: 'inquiry/popup/typeAndAdmin',
        name: 'TypeAndAdmin',
        component: TypeAndAdmin,
      },
      {
        path: 'inquiry/popup/:inquiryNo',
        name: 'InquiryDetailPopupIframe',
        component: InquiryDetailPopupIframe,
      },
      {
        path: 'inquiry/popup/prev/:inquiryNo',
        name: 'InquiryDetailPopup',
        component: InquiryDetailPopup,
      },
      {
        path: 'accumulation/popup/paymentList',
        name: 'PaymentListPopup',
        component: PaymentListPopup,
      },
      {
        path: 'accumulation/popup/payment/displayGradeInfo',
        name: 'DisplayGradeInfoPopup',
        component: DisplayGradeInfoPopup,
      },
      {
        path: 'accumulation/popup/payment/displayGroupInfo',
        name: 'DisplayGroupInfoPopup',
        component: DisplayGroupInfoPopup,
      },
      {
        path: 'accumulation/list',
        name: 'AccumulationPopup',
        component: AccumulationPopup,
        meta: {
          excelCreateMenuKey: 'PREMIUM_ACCUMULATION_SUMMARY_DETAIL',
        },
      },
      {
        path: 'sms/popup/template-list',
        name: 'SmsTemplateList',
        component: SmsTemplateList,
      },
      {
        path: 'sms/popup/recipient-list',
        name: 'SmsRecipientList',
        component: SmsRecipientList,
        meta: {
          historyName: 'POPUP_SMS_RECEIVER_SEARCH',
        },
      },
      {
        path: 'mail/popup/template-list',
        name: 'TemplateList',
        component: TemplateList,
      },
      {
        path: 'mail/popup/recipient-list',
        name: 'RecipientList',
        component: RecipientList,
        meta: {
          historyName: 'POPUP_EMAIL_RECEIVER_SEARCH',
        },
      },
      // 프로모션관리
      {
        path: 'promotion/coupon/use-list',
        name: 'CouponUseListPopup',
        component: CouponUseListPopup,
        meta: {
          excelCreateMenuKey: 'PREMIUM_COUPON_USE_LIST',
        },
      },
      {
        path: 'promotion/coupon/issue-plan/popup/detail',
        name: 'CouponPopupDetail',
        component: CouponPopupDetail,
        meta: {
          excelCreateMenuKey: 'PREMIUM_COUPON_ISSUE_LIST',
        },
      },
      {
        path: 'promotion/popup/member-target/detail',
        name: 'MemberTargetDetail',
        component: MemberTargetDetail,
      },
      {
        path: 'promotion/popup/member-target/detail/member-grade',
        name: 'DiscountTargetMember',
        component: DiscountTargetMember,
      },
      // 파트너관리
      {
        path: 'partner/popup/contract-files',
        name: 'ContractDown',
        component: ContractDown,
      },
      {
        path: '/partner/popup/change-md',
        name: 'ChangeMd',
        component: ChangeMd,
      },
      {
        path: 'contract/standingPointContract/popup',
        name: 'PopupContract',
        component: PopupContract,
      },
      // 서비스관리
      {
        path: 'authorityGroup/popup',
        name: 'GroupPopup',
        component: GroupPopup,
      },
      {
        path: 'terms/popup/:tabName',
        name: 'HistoryPop',
        component: HistoryPop,
      },
      {
        path: 'board/popup/faq/:faqNo',
        name: 'QueryFaq',
        component: QueryFaqByFaqNo,
      },
      {
        path: 'board/popup/article/move',
        name: 'ArticleMove',
        component: ArticleMove,
      },
      {
        path: 'board/popup/article/form',
        name: 'ArticleForm',
        component: ArticleForm,
      },
      {
        path: 'board/popup/article/:articleNo/form',
        name: 'ArticleArticleNoForm',
        component: ArticleForm,
      },
      {
        path: 'mall/popup/settlement-excel',
        name: 'SettlementExcelPopup',
        component: SettlementExcelPopup,
      },
      // 통계
      // 정산관리
      {
        path: 'feepolicy/guide',
        name: 'FeePolicyGuide',
        component: FeePolicyGuide,
      },
      // ETC
      {
        path: 'address/search/popup',
        name: 'AddressPopup',
        component: AddressPopup,
        meta: {
          nonMember: true,
        },
      },
    ],
  },

  // Not Common root
  {
    path: '/design/editor',
    name: 'DesignEditor',
    component: DesignEditor,
  },
  {
    path: '/popup/excel-download',
    name: 'ServerExcelDownload',
    component: ServerExcelDownloadIframe,
  },
  {
    path: '/product/popup/copyMallProduct',
    name: 'CopyMallProduct',
    component: CopyMallProduct,
  },
  {
    path: '/product/customProperty/popup/:propertyValueNo',
    name: 'PopupCustomProperty',
    component: PopupCustomProperty,
  },
  {
    path: '/product/popup/ManagementCustomProperty',
    name: 'ManagementCustomProperty',
    component: ManagementCustomProperty,
  },
  {
    path: '/product/popup/customProperty/:mallProductNos/:propertyValue',
    name: 'customProperty',
    component: CustomProperty,
  },
  {
    path: '/product/judgement/:mallProductNo',
    name: 'ProductScreeningPopupIframe',
    component: ProductScreeningPopupIframe,
  },
  {
    path: '/product/search/popup',
    name: 'ProductPopSearch',
    component: ProductPopSearch,
  },
  {
    path: '/product/popup/displayCategoryInfo',
    name: 'DisplayCategoryInfo',
    component: DisplayCategoryInfo,
  },
  {
    path: '/product/popup/edit/:mallNo/:mallProductNo/images/:readOnly',
    name: 'EditImages',
    component: EditImages,
  },
  {
    path: '/product/popup/modifySaleStatus/:mallProductNos',
    name: 'ModifySaleStatus',
    component: ModifySaleStatus,
  },
  {
    path: '/product/popup/ModifySalePriceAndImmediateDiscount',
    name: 'ModifySalePriceAndImmediateDiscount',
    component: ModifySalePriceAndImmediateDiscount,
  },
  {
    path: '/product/popup/modifyFrontDisplay/:mallProductNos',
    name: 'ModifyFrontDisplay',
    component: ModifyFrontDisplay,
  },
  {
    path: '/product/popup/modifySalePeriod/:mallProductNos',
    name: 'ModifySalePeriod',
    component: ModifySalePeriod,
  },
  {
    path: '/product/popup/modifySalePrice/:mallProductNos',
    name: 'ModifySalePrice',
    component: ModifySalePrice,
  },
  {
    path: '/product/popup/modifyImmediateDiscount/:mallProductNos',
    name: 'ModifyImmediateDiscount',
    component: ModifyImmediateDiscount,
  },
  {
    path: '/product/popup/modifyPromotionText/:mallProductNos',
    name: 'ModifyPromotionText',
    component: ModifyPromotionText,
  },
  {
    path: '/product/popup/changeAdmin',
    name: 'ChangeAdmin',
    component: ChangeAdmin,
  },
  {
    path: '/product/judgement/batchConfirm/:mallProductNos',
    name: 'BatchConfirm',
    component: BatchConfirm,
  },
  {
    path: '/product/popup/urlDirectDisplay/:mallProductNos',
    name: 'UrlDirectDisplay',
    component: UrlDirectDisplay,
  },
  {
    path: '/product/popup/promotionsChange/:mallProductNos',
    name: 'PromotionsChange',
    component: PromotionsChange,
  },
  {
    path: '/product/popup/priceComparison',
    name: 'PriceComparisonIframe',
    component: PriceComparisonIframe,
  },
  {
    path: '/product/popup/commissionPurchase',
    name: 'CommissionPurchaseIframe',
    component: CommissionPurchaseIframe,
  },
  {
    path: '/product/popup/comparingPriceSite/:mallProductNos',
    name: 'comparingPriceSite',
    component: ComparingPriceSite,
  },
  {
    path: '/product/popup/iconChange',
    name: 'IconChangeIframe',
    component: IconChangeIframe,
  },
  {
    path: '/popup/product-options',
    name: 'ProductOptionsPopupIframe',
    component: ProductOptionsPopupIframe,
  },
  {
    path: '/popup/global-product-options/:type',
    name: 'GlobalProductOptionsPopupIframe',
    component: GlobalProductOptionsPopupIframe,
  },
  {
    path: '/popup/category-list',
    name: 'ProductCategoryListPopupIframe',
    component: ProductCategoryListPopupIframe,
  },
  {
    path: '/popup/delivery-date',
    name: 'ProductDeliveryDatePopupIframe',
    component: ProductDeliveryDatePopupIframe,
  },
  {
    path: '/popup/product-custom-properties',
    name: 'ProductCustomPropertiesPopupIframe',
    component: ProductCustomPropertiesPopupIframe,
  },
  {
    path: '/popup/product-delivery-info',
    name: 'ProductDeliveryInfoPopupIframe',
    component: ProductDeliveryInfoPopupIframe,
  },
  {
    path: '/popup/product-description',
    name: 'ProductDescriptionPopupIframe',
    component: ProductDescriptionPopupIframe,
  },
  {
    path: '/popup/product-description-template/:segment',
    name: 'ProductDescriptionTemplatePopupIframe',
    component: ProductDescriptionTemplatePopupIframe,
  },
  {
    path: '/popup/product-discount-price',
    name: 'ProductDiscountPricePopupIframe',
    component: ProductDiscountPricePopupIframe,
  },
  {
    path: '/popup/product-discount-setting',
    name: 'ProductDiscountSettingPopupIframe',
    component: ProductDiscountSettingPopupIframe,
  },
  {
    path: '/popup/product-display-category-batch',
    name: 'ProductDisplayCategoryBatchPopupIframe',
    component: ProductDisplayCategoryBatchPopupIframe,
  },
  {
    path: '/popup/product-display-status',
    name: 'ProductDisplayStatusPopupIframe',
    component: ProductDisplayStatusPopupIframe,
  },
  {
    path: '/popup/product-exclude-in-search',
    name: 'ProductExcludeInSearchPopupIframe',
    component: ProductExcludeInSearchPopupIframe,
  },
  {
    path: '/popup/product-information-disclosure',
    name: 'ProductInformationDisclosurePopupIframe',
    component: ProductInformationDisclosurePopupIframe,
  },
  {
    path: '/popup/product-manager-batch',
    name: 'ProductManagerBatchPopupIframe',
    component: ProductManagerBatchPopupIframe,
  },
  {
    path: '/popup/product-promotion',
    name: 'ProductPromotionPopupIframe',
    component: ProductPromotionPopupIframe,
  },
  {
    path: '/popup/modify-promotion',
    name: 'ProductModifyPromotionPopupIframe',
    component: ProductModifyPromotionPopupIframe,
  },
  {
    path: '/popup/product-sales-period',
    name: 'ProductSalesPeriodPopupIframe',
    component: ProductSalesPeriodPopupIframe,
  },
  {
    path: '/popup/product-sales-price',
    name: 'ProductSalesPricePopupIframe',
    component: ProductSalesPricePopupIframe,
  },
  {
    path: '/popup/product-sales-status-setting',
    name: 'ProductSalesStatusSettingPopupIframe',
    component: ProductSalesStatusSettingPopupIframe,
  },
  {
    path: '/popup/product-screening',
    name: 'ProductScreeningPopupIframe',
    component: ProductScreeningPopupIframe,
  },
  {
    path: '/popup/product-screening-batch',
    name: 'ProductScreeningBatchPopupIframe',
    component: ProductScreeningBatchPopupIframe,
  },
  {
    path: '/popup/product-slogan',
    name: 'ProductSloganPopupIframe',
    component: ProductSloganPopupIframe,
  },
  {
    path: '/popup/product-option-search',
    name: 'ProductOptionSearchPopupIframe',
    component: ProductOptionSearchPopupIframe,
  },
  {
    path: '/popup/product-with-options-search',
    name: 'ProductWithOptionsSearchPopupIframe',
    component: ProductWithOptionsSearchPopupIframe,
  },
  {
    path: '/popup/copy-product',
    name: 'ProductCopyPopupIframe',
    component: ProductCopyPopupIframe,
  },
  {
    path: '/popup/group-management-code',
    name: 'ProductGroupManagementCodePopupIframe',
    component: ProductGroupManagementCodePopupIframe,
  },
  {
    path: '/popup/commission-purchase',
    name: 'ProductCommissionPurchasePopupIframe',
    component: ProductCommissionPurchasePopupIframe,
  },
  {
    path: '/popup/icon-change',
    name: 'ProductIconPopupIframe',
    component: ProductIconPopupIframe,
  },
  {
    path: '/popup/product-certification-info',
    name: 'ProductCertificationIframe',
    component: ProductCertificationIframe,
  },
  {
    path: '/product/popup/modifyPromotion/:mallProductNos',
    name: 'modifyPromotion',
    component: ModifyPromotion,
  },
  {
    path: '/product/popup/modifyDelivery/:mallNo/:partnerNo/:mallProductNos',
    name: 'modifyDelivery',
    component: ModifyDelivery,
  },
  {
    path: '/product/popup/edit/:mallProductNos/delivery-date',
    name: 'deliveryDate',
    component: DeliveryDate,
  },
  {
    path: '/product/popup/edit/groupManagementCode',
    name: 'EditGroupManagementCode',
    component: EditGroupManagementCodeIframe,
  },
  {
    path: '/order/first-discount',
    name: 'OrderFirstDiscount',
    component: OrderFirstDiscount,
  },
  {
    path: '/order/last-discount',
    name: 'OrderLasttDiscount',
    component: OrderFirstDiscount,
  },
  {
    path: '/order/benefit',
    name: 'Benefit',
    component: Benefit,
  },
  {
    path: '/order/free-gifts',
    name: 'FreeGifts',
    component: FreeGifts,
  },
  {
    path: '/delivery/first-amt-detail',
    name: 'DeliveryFirstAmtDetail',
    component: DeliveryFirstAmtDetail,
  },
  {
    path: '/delivery/last-amt-detail',
    name: 'DeliveryLastAmtDetail',
    component: DeliveryFirstAmtDetail,
  },
  {
    path: '/claim/exchangeProduct',
    name: 'ExchangeProduct',
    component: ExchangeProduct,
  },
  {
    path: '/claim/cs/modifyPopup',
    name: 'CsModifyPopup',
    component: CsModifyPopup,
  },
  {
    path: '/claim/cancelPopup',
    name: 'CancelPopup',
    component: CancelPopup,
  },
  {
    path: '/claim/exchangePopup',
    name: 'ExchangePopup',
    component: ExchangePopup,
  },
  {
    path: '/claim/modify/address',
    name: 'ModifyAddress',
    component: ModifyAddress,
  },
  {
    path: '/claim/returnPopup',
    name: 'ReturnPopup',
    component: ReturnPopup,
  },
  {
    path: '/claim/cancelAllPopup',
    name: 'CancelAllPopup',
    component: CancelAllPopup,
  },
  {
    path: '/banner/displayConfig',
    name: 'PopupBannerDisplayOption',
    component: PopupBannerDisplayOption,
  },
  {
    path: '/board/popup/notice/form',
    name: 'AddNotice',
    component: EditNoticeByNoticeNo,
  },
  {
    path: '/board/popup/notice/:noticeNo/form',
    name: 'EditNotice',
    component: EditNoticeByNoticeNo,
  },
  {
    path: '/board/popup/notice/move/:noticeNos',
    name: 'NoticeListMoveNotice',
    component: NoticeListMoveNotice,
  },
  {
    path: '/board/popup/notice/:noticeNo',
    name: 'QueryNotice',
    component: QueryNoticeByNoticeNo,
  },

  {
    path: '/popup/variable-guide',
    name: 'ExternalScriptVariableGuide',
    component: ExternalScriptVariableGuide,
  },

  // ETC
  {
    path: '',
    component: ServiceRegisterView,
    children: [
      {
        path: 'service/agreeTermsForm',
        name: 'ServiceRegisterAgreeTerms',
        component: ServiceRegisterAgreeTerms,
        meta: {
          nonMember: true,
        },
      },
      {
        path: 'service/registerForm',
        name: 'ServiceRegisterForm',
        component: ServiceRegisterForm,
        meta: {
          nonMember: true,
        },
      },
      {
        path: 'admin/service/master/registerForm',
        name: 'ServiceMasterRegisterForm',
        component: ServiceMasterRegisterForm,
        meta: {
          nonMember: true,
        },
      },
      {
        path: 'admin/service/master/registerCompletePage',
        name: 'ServiceMasterRegisterCompletePage',
        component: ServiceMasterRegisterCompletePage,
        meta: {
          nonMember: true,
        },
      },
    ],
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/admin/service/agreeTermsForm',
    name: 'AgreeTermsForm',
    redirect: '/admin/service/registerForm',
    component: AgreeTermsForm,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/admin/service/registerForm-prev',
    name: 'RegisterFormPrev',
    component: RegisterForm,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/admin/service/registerForm',
    name: 'RegisterForm',
    component: RegisterFormIframe,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/admin/service/registerForm/:type',
    name: 'RegisterForm',
    component: RegisterFormIframe,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/admin/service/registerCompletePage',
    name: 'RegisterCompletePage',
    component: RegisterCompletePage,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/profile/password-mail',
    name: 'AdminPasswordByKey',
    component: AdminPasswordByKey,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/memberNotFound',
    name: 'MemberNotFound',
    component: MemberNotFound,
  },
  {
    path: '/claimNotFound',
    name: 'ClaimNotFound',
    component: ClaimNotFound,
  },
  {
    path: '/footer/service/privacy',
    name: 'FooterServicePrivacy',
    component: FooterServicePrivacy,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/footer/service/privacy',
    name: 'FooterServicePrivacyOld',
    component: FooterServicePrivacyOld,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/instagram/code',
    name: 'InstagramCodeReceiver',
    component: InstagramCodeReceiver,
  },
  {
    path: '/error-page/unauthorized',
    name: 'ErrorPageUnauthorized',
    component: ErrorPageUnauthorized,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/nopermission',
    name: 'NoPermission',
    component: NoPermission,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      nonMember: true,
    },
  },
  {
    path: '/*',
    name: 'MemberHasDetach',
    component: MemberHasDetach,
  },
];

export default routes;
